import { Component, HostListener, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription, forkJoin, of, Observable, timer } from 'rxjs';
import { map, catchError, take } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConsultarDocumentosService } from '../../../../../../services/cotizador-contratante/consultar-documentos.service';
import { ConsultarContratanteService } from '../../../../../../services/cotizador-contratante/consultar-contratante.service';
import { ConsultarAsesorByIDService } from '../../../../../../services/cotizador-contratante/consultar-asesor-by-id.service';
import { NetworkingQuotation } from '../../../../../../services/servicioCotizador/cotizador.service';
import { ContratanteData, CotizacionPrevia } from '../../../../../../models/cotizador-contratante/consultar-contratante/response/consultar-contratante-response.model';
import { ConsultarAsesorByIDRequest } from '../../../../../../models/cotizador-contratante/consultar-asesor/request/consultar-asesor-byID-request.model';
import { ContratosActivos } from '../../../../../../models/cotizador/response/model.data.response';
import { QuotationPeopleResponse } from '../../../../../../models/cotizador/response/model.data.response';
import { ModalSeleccionProgramasComponent } from '../modal-seleccion-programas/modal-seleccion-programas.component';
import { ModalValidacionUsuarioComponent } from '../modal-validacion-usuario/modal-validacion-usuario.component';
import { PopUpMensajeComponent, PopUpMensajeData } from '../pop-up-mensaje/pop-up-mensaje.component';
import { CotizacionesIncompletasService } from '../../../../../../services/cotizador-contratante/cotizaciones-incompletas.service';
import { ConsultarProgramasContratanteService } from '../../../../../../services/cotizador-contratante/consultar-programas-contratante.service';
import { ConsultarProgramasContratanteItem } from '../../../../../../models/cotizador-contratante/consultar-programas-contratante/response/consultar-programas-contratante-response.model';
import { CotizacionContratanteActual } from '../../../../../../models/cotizador-contratante/cotizacion-contratante-actual.model';
import {
  KEY_COTIZACION_CONTRATANTE_SESION_ACTIVA,
  KEY_COTIZACION_CREADA_DESDE_CONTRATANTE
} from '../../../../../../models/cotizador-contratante/crear cotizacion/cotizacion-creada-contratante-guardada.model';
import { ProgramaSeleccionStore } from '../../../../../../services/cotizador-contratante/programa-seleccion.store';
import {
  ContextoEdicionModalContratante,
  CotizacionEdicionContratanteContexto,
  CotizacionPrecargadaContexto
} from '../../../../../../models/cotizador-contratante/cotizacion-edicion-contexto.model';

@Component({
  selector: 'app-formulario-contratante',
  templateUrl: './formulario-contratante.component.html',
  styleUrls: ['./formulario-contratante.component.css']
})
export class FormularioContratanteComponent implements OnInit, OnDestroy {

  formContratante!: FormGroup;
  listaTipoDocumento: any[] = [];
  edad: number = 0;
  fechaMinima: Date;
  fechaMaxima: Date;
  buscando: boolean = false;
  nombreAsesor: string = '';
  // Map para almacenar nombres de asesores por su ID: idAsesor -> nombreCompleto
  private nombresAsesores: Map<string, string> = new Map();
  private formSubscription?: Subscription;                                                                                       
  /** true cuando el componente fue inicializado desde el flujo de edición (mis-cotizaciones → iniciar-edicion).
   *  Variable de instancia (no getter) — inmune a race conditions de localStorage. */
  private _editModeActive = false;
  private _edicionPasoActual = 0;
  private _edicionIdTipoSolicitud: number | null = null;
  private _edicionTieneProgramasPersistidos = false;
  private _edicionProgramasContratantePersistidos: any[] = [];
  private _reiniciarProgramasPorCambioPlan = false;
  /** Para detectar cambio de documento y limpiar validaciones_contratante y programas_contratante */
  private ultimoDoc: { tipo: string; num: string } | null = null;

  /** Códigos de tipo de documento que no pueden ser contratante (bebé/menor). */
  private readonly CODIGOS_NO_CONTRATANTE = ['BG', 'CN', 'RC'];

  /** Cache del IdAsesor del logueado cuando es venta nueva (se obtiene consultando al endpoint local). */
  private idAsesorLogueadoCache: string | null = null;

  /**
   * Letras latinas (incl. ñ/tildes), dígitos y espacio.
   * NC0107: AFILMED trae QUIÑONES/ORDOÑEZ; el patrón ASCII invalidaba el form y apagaba CONSULTAR.
   */
  private readonly patronNombreApellidoLetrasEspacio = /^[a-zA-ZáéíóúüñÁÉÍÓÚÜÑ0-9 ]*$/;

  /** A-Z, a-z, 0-9 únicamente; sin espacios, tildes ni eñe (COTIZADOR_CONTRATANTE_0004 / NC). */
  private readonly patronNumeroDocumentoAlfanumerico = /^[a-zA-Z0-9]*$/;

  private readonly camposNombreApellidoContratante: ReadonlyArray<string> = [
    'primerNombre',
    'segundoNombre',
    'primerApellido',
    'segundoApellido',
  ];

  constructor(
    private fb: FormBuilder,
    // private contratanteBusquedaService: ContratanteBusquedaService, // TODO: Descomentar cuando el servicio esté creado
    private consultarDocumentosService: ConsultarDocumentosService,
    private consultarContratanteService: ConsultarContratanteService,
    private consultarAsesorByIDService: ConsultarAsesorByIDService,
    private cotizacionesIncompletasService: CotizacionesIncompletasService,
    private consultarProgramasContratanteService: ConsultarProgramasContratanteService,
    private programaSeleccionStore: ProgramaSeleccionStore,
    private networkingQuotation: NetworkingQuotation,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef
  ) {
    const hoy = new Date();
    this.fechaMaxima = hoy;
    this.fechaMinima = new Date(hoy.getFullYear() - 100, hoy.getMonth(), hoy.getDate());
  }

  ngOnInit(): void {
    // No borrar datosRQ002_Contratante aquí: solo se borra al presionar la lupa (documento distinto) o en limpiarFormulario
    this.inicializarFormulario();
    this.cargarTiposDocumento();

    // Cargar datos de contrato_radicado si existe
    this.cargarDatosDesdeLocalStorage();
    // Hidratar idAsesor desde usuario logueado sin depender de la lupa.
    this.asegurarIdAsesorEnStorage();

    // NO cargar nombre del asesor aquí - solo se carga después de buscar contratante
    // si hay cotizaciones previas con asesores diferentes

    // Suscribirse a cambios del formulario para actualizar localStorage reactivamente
    this.suscribirACambiosFormulario();

    // Si ya hay un contexto de edición activo en localStorage (cotizacion_precargada.editMode === true),
    // restaurar _editModeActive ANTES de decidir qué keys limpiar.
    // Esto hace que ngOnInit sea idempotente en editMode: si el componente se destruye y
    // re-monta (cambio de pestaña) no pierde el estado de edición.
    let yaEnEditMode = false;
    try {
      const rawPrecInit = localStorage.getItem(this.KEY_COTIZACION_PRECARGADA);
      const contextoInicial: CotizacionPrecargadaContexto | null = rawPrecInit ? JSON.parse(rawPrecInit) : null;
      yaEnEditMode = contextoInicial?.editMode === true;
      if (yaEnEditMode && contextoInicial) {
        this._edicionPasoActual = Number(contextoInicial.pasoActual ?? 0);
        this._edicionIdTipoSolicitud = contextoInicial.idTipoSolicitud ?? null;
        this._edicionTieneProgramasPersistidos = contextoInicial.tieneProgramasContratantePersistidos === true;
        this._edicionProgramasContratantePersistidos = Array.isArray(contextoInicial.programasContratantePersistidos)
          ? contextoInicial.programasContratantePersistidos
          : [];
        this._reiniciarProgramasPorCambioPlan = contextoInicial.reiniciarProgramasPorCambioPlan === true;
      }
    } catch (_) { }

    // Verificar si hay una cotización de creación en progreso en ESTA visita (sessionStorage).
    // localStorage sobrevive al F5; sessionStorage no. Así, tras recarga se limpia la sesión fantasma
    // y no se bloquea tipo/número documento al digitar la misma cédula.
    // Dentro de la misma pestaña (p. ej. ir a beneficiario y volver) la flag vive y se preservan keys.
    const sesionActiva = !!sessionStorage.getItem(KEY_COTIZACION_CONTRATANTE_SESION_ACTIVA);

    if (yaEnEditMode) {
      // Edición activa: restaurar bandera de instancia y NO limpiar las keys de edición.
      this._editModeActive = true;
    } else if (!sesionActiva) {
      // Visita nueva o post-F5: limpiar residuos de localStorage que disparaban el bloqueo.
      localStorage.removeItem(this.KEY_COTIZACION_PRECARGADA);
      localStorage.removeItem(this.KEY_PROGRAMAS_CONTRATANTE);
      localStorage.removeItem(this.KEY_COTIZACION_ACTUAL);
      localStorage.removeItem(KEY_COTIZACION_CREADA_DESDE_CONTRATANTE);
      this.cotizacionesIncompletasService.limpiarSnapshotDatosContratante();
      // Beneficiarios de una cotización anterior no deben sobrevivir al F5 / visita nueva.
      this.limpiarBeneficiariosLocalGuardados();
    }
    // Si sesionActiva === true: preservar keys (usuario regresa de beneficiario / sigue en la misma visita).

    // Precargar datos del contratante si se viene desde edición
    this.intentarPrecargarDesdeEdicion();
  }

  ngOnDestroy(): void {
    // Limpiar suscripción al destruir el componente
    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
  }

  /** Escucha el evento emitido por el cotizador al cambiar de versión en modo edición */
  @HostListener('window:cotizacion-edicion-contratante')
  onEdicionContratanteEvent(): void {
    this.intentarPrecargarDesdeEdicion();
  }

  /**
   * Suscribirse a cambios del formulario para guardar automáticamente en localStorage.
   * No se borran keys aquí (ni al escribir ni al pegar): validaciones/programas/cotización solo se borran
   * al presionar la lupa (buscarContratante) cuando el documento es distinto, o en limpiarFormulario.
   */
  private suscribirACambiosFormulario(): void {
    this.formSubscription = this.formContratante.valueChanges.subscribe(() => {
      const tipo = (this.formContratante.get('tipoDocumento')?.value ?? '').toString().trim();
      const num = (this.formContratante.get('numeroDocumento')?.value ?? '').toString().trim();
      this.ultimoDoc = { tipo, num };
      this.actualizarValidacionTarjetaIdentidadEdad();
      this.guardarEnLocalStorage();
    });
  }

  inicializarFormulario(): void {
    this.formContratante = this.fb.group({
      // Datos de identificación
      tipoDocumento: ['', [Validators.required]],
      numeroDocumento: [
        '',
        [
          Validators.required,
          Validators.maxLength(30),
          Validators.pattern(this.patronNumeroDocumentoAlfanumerico),
        ],
      ],

      // Datos personales (RQ002)
      primerNombre: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(40),
          Validators.pattern(this.patronNombreApellidoLetrasEspacio),
        ],
      ],
      segundoNombre: [
        '',
        [
          Validators.minLength(3),
          Validators.maxLength(40),
          Validators.pattern(this.patronNombreApellidoLetrasEspacio),
        ],
      ],
      primerApellido: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(40),
          Validators.pattern(this.patronNombreApellidoLetrasEspacio),
        ],
      ],
      segundoApellido: [
        '',
        [
          Validators.minLength(3),
          Validators.maxLength(40),
          Validators.pattern(this.patronNombreApellidoLetrasEspacio),
        ],
      ],
      genero: ['', [Validators.required]],
      fechaNacimiento: ['', [Validators.required, this.validarEdadMinima.bind(this)]],

      // Datos de contacto (RQ002)
      emailPrincipal: ['', [Validators.required, Validators.email]],
      emailSecundario: ['', [Validators.email, Validators.maxLength(100)]],
      telefono: ['', [Validators.required, Validators.minLength(7), Validators.maxLength(15)]],
      telefonoFijo: ['', [Validators.minLength(7), Validators.maxLength(10)]]
    });
  }

  cargarTiposDocumento(): void {
    this.consultarDocumentosService.consultarDocumentos().subscribe({
      next: (response) => {
        console.log('Respuesta del servicio de tipos de documento:', response);
        // Mapear la respuesta del servicio al formato esperado
        if (response.status && response.data && response.data.length > 0) {
          this.listaTipoDocumento = response.data.map(doc => ({
            codigo: doc.codigo,
            descripcion: doc.tipo_documento.toUpperCase()
          }));
        } else {
          // Si no hay datos en la respuesta, mostrar error
          this.mostrarErrorCargarDocumentos();
          this.listaTipoDocumento = [];
        }
      },
      error: (error) => {
        console.error('Error al cargar tipos de documento:', error);
        // Mostrar pop-up de error y no cargar nada
        this.mostrarErrorCargarDocumentos();
        this.listaTipoDocumento = [];
      }
    });
  }

  /**
   * Muestra el pop-up de error cuando falla la carga de tipos de documento
   */
  private mostrarErrorCargarDocumentos(): void {
    const dialogRef = this.dialog.open(PopUpMensajeComponent, {
      width: '500px',
      maxWidth: '90vw',
      disableClose: true,
      data: {
        titulo: 'Error al cargar tipos de documento',
        texto: 'No se pudo cargar la lista de tipos de documento desde el servidor. Si el problema persiste, contacte al administrador del sistema.',
        tipoIcono: 'error',
        textoBoton: 'ACEPTAR'
      } as PopUpMensajeData
    });

    dialogRef.afterClosed().subscribe(() => {
      // El usuario cerró el pop-up, no necesitamos hacer nada adicional
    });
  }

  /**
   * Buscar contratante usando la lupa (REGISTRADURÍA/AFILMED)
   * Solo precarga datos básicos en el formulario, NO abre modales
   */
  buscarContratante(): void {
    // En modo edición la lupa no debe ejecutar una nueva búsqueda.
    if (this.esEditMode) return;
    // Venta nueva: documento inmutable tras crear cotización en BD.
    if (this.documentoBloqueadoPorCotizacion) return;
    if (!this.puedeConsultar()) {
      this.formContratante.get('tipoDocumento')?.markAsTouched();
      this.formContratante.get('numeroDocumento')?.markAsTouched();
      return;
    }

    this.buscando = true;
    this.spinner.show();
    this.idAsesorLogueadoCache = null;

    const tipoDoc = this.formContratante.get('tipoDocumento')?.value;
    const numDoc = this.formContratante.get('numeroDocumento')?.value;
    const tipoActual = (tipoDoc ?? '').toString().trim();
    const numActual = (numDoc ?? '').toString().trim();

    // Solo al presionar la lupa: si el documento del form no coincide con el de las keys guardadas, borrar todo.
    // Usamos validaciones_contratante (tipoDocumento + idContratante) como referencia porque valueChanges
    // ya actualiza datosRQ002_Contratante con el form, y ahí siempre coincidiría al dar la lupa.
    let documentoDiferente = false;
    const validacionesStr = localStorage.getItem(this.KEY_VALIDACIONES_CONTRATANTE);
    if (validacionesStr) {
      try {
        const validaciones = JSON.parse(validacionesStr);
        const tipoDeKeys = (validaciones.tipoDocumento ?? '').toString().trim();
        const numDeKeys = (validaciones.idContratante ?? '').toString().trim();
        documentoDiferente = tipoDeKeys !== tipoActual || numDeKeys !== numActual;
      } catch (_) {
        documentoDiferente = true;
      }
    } else {
      const datosStr = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
      if (datosStr) {
        try {
          const datos = JSON.parse(datosStr);
          const tipoGuardado = (datos.tipoDocumento ?? '').toString().trim();
          const numGuardado = (datos.numeroDocumento ?? '').toString().trim();
          documentoDiferente = tipoGuardado !== tipoActual || numGuardado !== numActual;
        } catch (_) {
          documentoDiferente = true;
        }
      }
    }
    if (documentoDiferente) {
      localStorage.removeItem(this.KEY_DATOS_CONTRATANTE);
      localStorage.removeItem(this.KEY_VALIDACIONES_CONTRATANTE);
      localStorage.removeItem(this.KEY_PROGRAMAS_CONTRATANTE);
      localStorage.removeItem(this.KEY_COTIZACION_ACTUAL);
      localStorage.removeItem(this.KEY_COTIZACION_PRECARGADA);
      localStorage.removeItem(KEY_COTIZACION_CREADA_DESDE_CONTRATANTE);
      sessionStorage.removeItem(KEY_COTIZACION_CONTRATANTE_SESION_ACTIVA);
      this.cotizacionesIncompletasService.limpiarSnapshotDatosContratante();
      this.limpiarBeneficiariosLocalGuardados();
    }
    this.ultimoDoc = { tipo: (tipoDoc ?? '').toString().trim(), num: (numDoc ?? '').toString().trim() };

    // Llamar al servicio de consulta de contratante
    this.consultarContratanteService.consultarContratante({
      tipoDocumento: tipoDoc,
      numeroDocumento: numDoc
    }).subscribe({
      next: (response) => {
        this.buscando = false;
        this.spinner.hide();

        // Console log de la respuesta completa
        console.log('Respuesta completa del servicio consultarContratante:', response);

        // Si la respuesta es exitosa y tiene datos, precargar solo los campos que no sean null
        if (response.status && response.data) {
          const cotizacionesPrevias = response.data.informacionCotizacionesPrevias?.cotizaciones ?? [];
          const sinDatosAfilmedYSinPrevias =
            response.data.encontradoEnAfilmed === false && cotizacionesPrevias.length === 0;

          if (sinDatosAfilmedYSinPrevias) {
            this.limpiarDatosContratanteTrasBusquedaSinExito(tipoDoc, numDoc);
            this.mostrarMensajeError(tipoDoc, numDoc);
            return;
          }

          this.precargarDatosContratante(response.data);
          // Actualizar esUsuario en storage desde consultarContratante (backend envía 'S'/'N')
          const esUsuarioDesdeConsulta = (response.data.esUsuario ?? '').toString().trim().toUpperCase() === 'S';
          this.guardarEnLocalStorage({ esUsuario: esUsuarioDesdeConsulta });

          const tipoSolicitud = localStorage.getItem(this.KEY_TIPO_SOLICITUD);
          const hayCotizacionesPrevias = response.data.encontradoEnCotizacionPrevia &&
            response.data.informacionCotizacionesPrevias?.cotizaciones?.length > 0;

          // Siempre obtener y guardar idAsesor en datosRQ002_Contratante (venta nueva o inclusión)
          this.obtenerIdAsesorLogueadoObservable().pipe(take(1)).subscribe(idAsesor => {
            const idAsesorNormalizado = (idAsesor ?? '').toString().trim();
            const extrasStorage: any = {
              ...(hayCotizacionesPrevias ? {} : { flagExisteCotizacionOtroAsesor: 'N' })
            };
            if (idAsesorNormalizado) {
              extrasStorage.idAsesor = idAsesorNormalizado;
            }
            this.guardarEnLocalStorage(extrasStorage);
            if (tipoSolicitud === '1' && idAsesorNormalizado) {
              this.idAsesorLogueadoCache = idAsesorNormalizado;
            }
            if (hayCotizacionesPrevias) {
              // Retoma de INCOMPLETA solo vía Mis Cotizaciones → Editar (no precargar desde CONSULTAR).
              if (!idAsesorNormalizado) {
                console.warn('No se pudo obtener el IdAsesor del usuario logueado (contrato_radicado ni sesión).');
              } else {
                this.procesarAsesoresCotizacionesPrevias(response.data.informacionCotizacionesPrevias.cotizaciones).subscribe({
                  next: () => {
                    this.verificarAsesoresCotizacionesPrevias(response.data.informacionCotizacionesPrevias.cotizaciones);
                  },
                  error: (error) => {
                    console.error('Error al procesar asesores de cotizaciones previas:', error);
                    this.verificarAsesoresCotizacionesPrevias(response.data.informacionCotizacionesPrevias.cotizaciones);
                  }
                });
              }
            }
            if (tipoSolicitud === '1') {
              this.verificarContratoActivoAfilmedOtroAsesor(tipoDoc, numDoc);
            }
          });
        } else {
          this.limpiarDatosContratanteTrasBusquedaSinExito(tipoDoc, numDoc);
          this.mostrarMensajeError(tipoDoc, numDoc);
        }
      },
      error: (error) => {
        this.buscando = false;
        this.spinner.hide();
        console.error('Error en búsqueda de contratante:', error);
        this.limpiarDatosContratanteTrasBusquedaSinExito(tipoDoc, numDoc);
        this.mostrarMensajeError(tipoDoc, numDoc);
      }
    });
  }

  /**
   * Consultar validaciones completas (SARLAFT, ADRES, Historial)
   * Flujo: Abrir modal "¿Es usuario?" y luego modal de programas. Validaciones y programas se precargan solo desde localStorage (sin BD).
   */
  consultarValidaciones(): void {
    this.asegurarIdAsesorEnStorage();
    if (!this.puedeConsultarCompleto()) {
      Object.keys(this.formContratante.controls).forEach(key => {
        const control = this.formContratante.get(key);
        if (control && control.invalid && control.hasError('required')) {
          control.markAsTouched();
        }
      });
      return;
    }

    const tipoDoc = this.formContratante.get('tipoDocumento')?.value;
    const numDoc = this.formContratante.get('numeroDocumento')?.value;
    const datosContratante = this.obtenerDatosFormulario();

    console.log('[Store-Anexo-Trace] CONSULTAR click', {
      tipoDoc,
      numDoc,
      editModeActive: this._editModeActive,
      storeAnexo: (() => {
        try {
          const raw = localStorage.getItem(this.KEY_PROGRAMAS_CONTRATANTE);
          const parsed = raw ? JSON.parse(raw) : null;
          const arr = Array.isArray(parsed) ? parsed : (parsed?.programas ?? []);
          return arr.map((p: any) => ({
            programa: p?.programa,
            anexoCodigo: p?.anexoCodigo,
            tieneAnexoDetalle: !!p?.anexoDetalle,
          }));
        } catch { return []; }
      })(),
      cotizacion_precargada: (() => {
        try {
          return JSON.parse(localStorage.getItem(this.KEY_COTIZACION_PRECARGADA) || 'null');
        } catch { return null; }
      })(),
    });

    // En editMode se salta SIEMPRE el modal "¿Es usuario?" y se abre directamente el modal de programas.
    // Usar _editModeActive (variable de instancia) en lugar del getter de localStorage para ser inmune
    // a race conditions o limpiezas intermedias de la key cotizacion_precargada.
    if (this._editModeActive) {
      const rawDatos = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
      let esUsuarioEdit: boolean = false;
      if (rawDatos) {
        try {
          const d = JSON.parse(rawDatos);
          if (typeof d?.esUsuario === 'boolean') esUsuarioEdit = d.esUsuario;
        } catch (_) { }
      }

      let idCotEdit: number | undefined;
      try {
        const rawPrec = localStorage.getItem(this.KEY_COTIZACION_PRECARGADA);
        const p = rawPrec ? JSON.parse(rawPrec) : null;
        const id = Number(p?.idCotizacion);
        if (Number.isFinite(id) && id > 0) idCotEdit = id;
      } catch (_) { }

      if (esUsuarioEdit === true) {
        // En edición se muestran Resultados y Programas. Si la cotización quedó
        // en el paso Contratante sin programas persistidos, el usuario debe poder
        // seleccionarlos antes de continuar.
        this.guardarEleccionUsuario(tipoDoc, numDoc, true);
        this.dialog.open(ModalSeleccionProgramasComponent, {
          data: {
            tipoDocumento: tipoDoc,
            numeroDocumento: numDoc,
            datosContratante,
            esUsuario: true,
            validaciones: null,
            ...this.obtenerContextoEdicionModal(),
            ...(idCotEdit ? { idCotizacion: idCotEdit } : {})
          },
          ...this.getOpcionesDialogSeleccionProgramas()
        }).afterClosed().subscribe(r => {
          if (r && (r.accion === 'guardar' || r.accion === 'guardar_programas')) {
            this.guardarEnLocalStorage({ esUsuario: true });
          }
          this.refrescarEstadoContinuar();
        });
      } else {
        // esUsuario=false: mostrar modal de validacion, luego programas pasando idCotizacion
        // existente para NO crear una cotizacion nueva.
        this.dialog.open(ModalValidacionUsuarioComponent, {
          data: { tipoDocumento: tipoDoc, numeroDocumento: numDoc, datosContratante },
          width: '600px',
          maxWidth: '90vw',
          disableClose: true,
          panelClass: 'modal-validacion-usuario'
        }).afterClosed().subscribe(resultadoValidacion => {
          if (resultadoValidacion && resultadoValidacion.esUsuario !== undefined) {
            this.guardarEleccionUsuario(tipoDoc, numDoc, resultadoValidacion.esUsuario);
            this.dialog.open(ModalSeleccionProgramasComponent, {
              data: {
                tipoDocumento: tipoDoc,
                numeroDocumento: numDoc,
                datosContratante,
                esUsuario: resultadoValidacion.esUsuario,
                validaciones: resultadoValidacion.validaciones,
                ...this.obtenerContextoEdicionModal(),
                ...(idCotEdit ? { idCotizacion: idCotEdit } : {})
              },
              ...this.getOpcionesDialogSeleccionProgramas()
            }).afterClosed().subscribe(r => {
              if (r && (r.accion === 'guardar' || r.accion === 'guardar_programas')) {
                this.guardarEnLocalStorage({ esUsuario: resultadoValidacion.esUsuario });
              }
              this.refrescarEstadoContinuar();
            });
          }
        });
      }
      return;
    }

    this.abrirModalValidacionYProgramas(tipoDoc, numDoc, datosContratante);
  }

  /**
   * MatDialog: ancho fluido (98vw) si viewport ≤1400 (tablet 1340×800 y portátil).
   * Columnas multi-columna en CSS desde 1201px; colapso solo ≤1200px.
   * Altura: 96vh si viewport bajo (≤850px), sin forzar layout tablet por altura.
   */
  private getOpcionesDialogSeleccionProgramas(): {
    width: string;
    maxWidth: string;
    maxHeight: string;
    disableClose: boolean;
    panelClass: string;
  } {
    const w = typeof window !== 'undefined' ? window.innerWidth : 1920;
    const h = typeof window !== 'undefined' ? window.innerHeight : 1080;
    const esAnchoFluido = w <= 1400;
    return {
      width: esAnchoFluido ? '98vw' : '1400px',
      maxWidth: esAnchoFluido ? '98vw' : '1400px',
      maxHeight: h <= 850 ? '96vh' : '95vh',
      disableClose: true,
      panelClass: 'modal-seleccion-programas'
    };
  }

  private obtenerContextoEdicionModal(): Partial<ContextoEdicionModalContratante> {
    if (!this._editModeActive) return {};

    return {
      editMode: true,
      pasoActual: this._edicionPasoActual,
      idTipoSolicitud: this._edicionIdTipoSolicitud,
      tieneProgramasContratantePersistidos: this._edicionTieneProgramasPersistidos,
      programasContratantePersistidos: this._edicionProgramasContratantePersistidos,
      reiniciarProgramasPorCambioPlan: this._reiniciarProgramasPorCambioPlan
    };
  }

  private refrescarEstadoContinuar(): void {
    this.cdr.detectChanges();
  }

  /**
   * true si programas_contratante ya tiene evidencia de persistencia en BD
   * (idBenPrograma o guardadoEnBd). En ese caso no se debe repreguntar Sí/No.
   */
  private contratanteProgramasYaPersistidosEnBd(): boolean {
    try {
      const raw = localStorage.getItem(this.KEY_PROGRAMAS_CONTRATANTE);
      if (!raw) return false;
      const parsed = JSON.parse(raw);
      const programas = Array.isArray(parsed)
        ? parsed
        : (Array.isArray(parsed?.programas) ? parsed.programas : []);
      return programas.some((p: any) =>
        Number(p?.idBenPrograma ?? 0) > 0 || p?.guardadoEnBd === true
      );
    } catch {
      return false;
    }
  }

  /**
   * Abre el modal "¿Es usuario?" y luego el modal de selección de programas. Pasa idCotizacion si hay cotización actual para este documento.
   */
  private abrirModalValidacionYProgramas(tipoDoc: string, numDoc: string, datosContratante: any): void {
    // Programas del contratante ya en BD: no repreguntar Sí/No; abrir directo el modal de programas.
    if (this.contratanteProgramasYaPersistidosEnBd()) {
      let esUsuario = false;
      try {
        const rawDatos = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
        const d = rawDatos ? JSON.parse(rawDatos) : null;
        if (typeof d?.esUsuario === 'boolean') esUsuario = d.esUsuario;
      } catch { /* no-op */ }

      this.guardarEleccionUsuario(tipoDoc, numDoc, esUsuario);
      const idCotizacion = this.obtenerIdCotizacionActual(tipoDoc, numDoc);
      this.dialog.open(ModalSeleccionProgramasComponent, {
        data: {
          tipoDocumento: tipoDoc,
          numeroDocumento: numDoc,
          datosContratante,
          esUsuario,
          validaciones: null,
          ...this.obtenerContextoEdicionModal(),
          ...(idCotizacion ? { idCotizacion } : {})
        },
        ...this.getOpcionesDialogSeleccionProgramas()
      }).afterClosed().subscribe(resultado => {
        if (resultado && (resultado.accion === 'guardar' || resultado.accion === 'guardar_programas')) {
          this.guardarEnLocalStorage({ esUsuario });
        }
        this.refrescarEstadoContinuar();
      });
      return;
    }

    // Si ya hay precarga de una INCOMPLETA, no abrir de nuevo validación de usuario
    // (y saltar render de validación de cobertura dentro del modal de programas).
    try {
      const rawPrec = localStorage.getItem(this.KEY_COTIZACION_PRECARGADA);
      if (rawPrec) {
        const prec = JSON.parse(rawPrec);
        if (prec?.precargada === true) {
          const savedTipo = (prec?.tipoDocumento ?? '').toString().trim();
          const savedNum = (prec?.numeroDocumento ?? '').toString().trim();
          const tipoOk = savedTipo ? savedTipo === (tipoDoc ?? '').toString().trim() : true;
          const numOk = savedNum ? savedNum === (numDoc ?? '').toString().trim() : true;

          if (tipoOk && numOk) {
            const rawDatos = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
            let esUsuario: boolean | null = null;
            if (rawDatos) {
              const datos = JSON.parse(rawDatos);
              // En precarga se guarda como boolean
              if (typeof datos?.esUsuario === 'boolean') esUsuario = datos.esUsuario;
            }

            if (esUsuario !== null) {
              // Asegurar que datosRQ002_Contratante quede con la elección vigente
              this.guardarEleccionUsuario(tipoDoc, numDoc, esUsuario);

              const idCotizacion = prec?.idCotizacion ?? this.obtenerIdCotizacionActual(tipoDoc, numDoc);
              const dialogRefProgramas = this.dialog.open(ModalSeleccionProgramasComponent, {
                data: {
                  tipoDocumento: tipoDoc,
                  numeroDocumento: numDoc,
                  datosContratante: datosContratante,
                  esUsuario: esUsuario,
                  idCotizacion: idCotizacion ?? undefined
                },
                ...this.getOpcionesDialogSeleccionProgramas()
              });

              dialogRefProgramas.afterClosed().subscribe(resultado => {
                if (resultado && (resultado.accion === 'guardar' || resultado.accion === 'guardar_programas')) {
                  this.guardarEnLocalStorage({ esUsuario });
                }
                this.refrescarEstadoContinuar();
              });
              return;
            }
          }
        }
      }
    } catch (_) { }

    // ── MODO EDICIÓN (desde mis-cotizaciones) ────────────────────────────────
    // Si hay cotizacion_precargada con editMode:true se salta la re-validación
    // y se abre directamente el modal de programas con idCotizacion explícito.
    // (Requisito: "no se debe generar una nueva búsqueda, sino mostrar la info ya consultada")
    // NOTA: editMode:true solo lo escribe precargarDesdeEdicion(), que solo se invoca
    // al venir desde mis-cotizaciones → no afecta el flujo de creación nueva.
    try {
      const rawPrecEdit = localStorage.getItem(this.KEY_COTIZACION_PRECARGADA);
      if (rawPrecEdit) {
        const precEdit = JSON.parse(rawPrecEdit);
        const idCotizacionEdit = Number(precEdit?.idCotizacion);
        if (precEdit?.editMode === true && Number.isFinite(idCotizacionEdit) && idCotizacionEdit > 0) {
          const rawDatos = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
          let esUsuarioEdit: boolean = false;
          if (rawDatos) {
            try {
              const datos = JSON.parse(rawDatos);
              if (typeof datos?.esUsuario === 'boolean') esUsuarioEdit = datos.esUsuario;
            } catch (_) { }
          }

          if (esUsuarioEdit === true) {
            this.guardarEleccionUsuario(tipoDoc, numDoc, esUsuarioEdit);
            this.dialog.open(ModalSeleccionProgramasComponent, {
              data: {
                tipoDocumento: tipoDoc,
                numeroDocumento: numDoc,
                datosContratante,
                esUsuario: true,
                validaciones: null,
                ...this.obtenerContextoEdicionModal(),
                idCotizacion: idCotizacionEdit
              },
              ...this.getOpcionesDialogSeleccionProgramas()
            }).afterClosed().subscribe(resultado => {
              if (resultado && (resultado.accion === 'guardar' || resultado.accion === 'guardar_programas')) {
                this.guardarEnLocalStorage({ esUsuario: true });
              }
              this.refrescarEstadoContinuar();
            });
          } else {
            this.dialog.open(ModalValidacionUsuarioComponent, {
              data: { tipoDocumento: tipoDoc, numeroDocumento: numDoc, datosContratante: datosContratante },
              width: '600px',
              maxWidth: '90vw',
              disableClose: true,
              panelClass: 'modal-validacion-usuario'
            }).afterClosed().subscribe(resultadoValidacion => {
              if (resultadoValidacion && resultadoValidacion.esUsuario !== undefined) {
                this.guardarEleccionUsuario(tipoDoc, numDoc, resultadoValidacion.esUsuario);
                this.dialog.open(ModalSeleccionProgramasComponent, {
                  data: {
                    tipoDocumento: tipoDoc,
                    numeroDocumento: numDoc,
                    datosContratante: datosContratante,
                    esUsuario: resultadoValidacion.esUsuario,
                    validaciones: resultadoValidacion.validaciones,
                    ...this.obtenerContextoEdicionModal(),
                    idCotizacion: idCotizacionEdit
                  },
                  ...this.getOpcionesDialogSeleccionProgramas()
                }).afterClosed().subscribe(resultado => {
                  if (resultado && (resultado.accion === 'guardar' || resultado.accion === 'guardar_programas')) {
                    this.guardarEnLocalStorage({ esUsuario: resultadoValidacion.esUsuario });
                  }
                  this.refrescarEstadoContinuar();
                });
              }
            });
          }
          return;
        }
      }
    } catch (_) { }
    // ─────────────────────────────────────────────────────────────────────────

    // Safety net: si por cualquier motivo los bloques anteriores no detectaron el editMode,
    // verificar esEditMode aquí. En edición NUNCA abrir el modal de validación de usuario.
    if (this.esEditMode) {
      const rawDatosSafe = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
      let esUsuarioSafe: boolean = false;
      if (rawDatosSafe) {
        try {
          const d = JSON.parse(rawDatosSafe);
          if (typeof d?.esUsuario === 'boolean') esUsuarioSafe = d.esUsuario;
        } catch (_) { }
      }

      const rawPrecSafe = localStorage.getItem(this.KEY_COTIZACION_PRECARGADA);
      let idCotSafe: number | undefined;
      try {
        const p = rawPrecSafe ? JSON.parse(rawPrecSafe) : null;
        const id = Number(p?.idCotizacion);
        if (Number.isFinite(id) && id > 0) idCotSafe = id;
      } catch (_) { }

      if (esUsuarioSafe === true) {
        this.guardarEleccionUsuario(tipoDoc, numDoc, esUsuarioSafe);
        this.dialog.open(ModalSeleccionProgramasComponent, {
          data: {
            tipoDocumento: tipoDoc,
            numeroDocumento: numDoc,
            datosContratante,
            esUsuario: true,
            validaciones: null,
            ...this.obtenerContextoEdicionModal(),
            ...(idCotSafe ? { idCotizacion: idCotSafe } : {})
          },
          ...this.getOpcionesDialogSeleccionProgramas()
        }).afterClosed().subscribe(r => {
          if (r && (r.accion === 'guardar' || r.accion === 'guardar_programas')) {
            this.guardarEnLocalStorage({ esUsuario: true });
          }
          this.refrescarEstadoContinuar();
        });
      } else {
        this.dialog.open(ModalValidacionUsuarioComponent, {
          data: { tipoDocumento: tipoDoc, numeroDocumento: numDoc, datosContratante: datosContratante },
          width: '600px',
          maxWidth: '90vw',
          disableClose: true,
          panelClass: 'modal-validacion-usuario'
        }).afterClosed().subscribe(resultadoValidacion => {
          if (resultadoValidacion && resultadoValidacion.esUsuario !== undefined) {
            this.guardarEleccionUsuario(tipoDoc, numDoc, resultadoValidacion.esUsuario);
            this.dialog.open(ModalSeleccionProgramasComponent, {
              data: {
                tipoDocumento: tipoDoc,
                numeroDocumento: numDoc,
                datosContratante: datosContratante,
                esUsuario: resultadoValidacion.esUsuario,
                validaciones: resultadoValidacion.validaciones,
                ...this.obtenerContextoEdicionModal(),
                ...(idCotSafe ? { idCotizacion: idCotSafe } : {})
              },
              ...this.getOpcionesDialogSeleccionProgramas()
            }).afterClosed().subscribe(r => {
              if (r && (r.accion === 'guardar' || r.accion === 'guardar_programas')) {
                this.guardarEnLocalStorage({ esUsuario: resultadoValidacion.esUsuario });
              }
              this.refrescarEstadoContinuar();
            });
          }
        });
      }
      return;
    }

    const dialogRefValidacion = this.dialog.open(ModalValidacionUsuarioComponent, {
      data: {
        tipoDocumento: tipoDoc,
        numeroDocumento: numDoc,
        datosContratante: datosContratante
      },
      width: '600px',
      maxWidth: '90vw',
      disableClose: true,
      panelClass: 'modal-validacion-usuario'
    });

    dialogRefValidacion.afterClosed().subscribe(resultadoValidacion => {
      if (resultadoValidacion && resultadoValidacion.esUsuario !== undefined) {
        console.log('[Store-Anexo-Trace] Modal validación cerró', {
          esUsuario: resultadoValidacion.esUsuario,
          storeAnexoSinCambio: (() => {
            try {
              const raw = localStorage.getItem(this.KEY_PROGRAMAS_CONTRATANTE);
              const parsed = raw ? JSON.parse(raw) : null;
              const arr = Array.isArray(parsed) ? parsed : (parsed?.programas ?? []);
              return arr.map((p: any) => ({
                programa: p?.programa,
                tieneAnexoDetalle: !!p?.anexoDetalle,
              }));
            } catch { return []; }
          })(),
        });

        this.guardarEleccionUsuario(tipoDoc, numDoc, resultadoValidacion.esUsuario);

        const idCotizacion = this.obtenerIdCotizacionActual(tipoDoc, numDoc);
        const dialogRefProgramas = this.dialog.open(ModalSeleccionProgramasComponent, {
          data: {
            tipoDocumento: tipoDoc,
            numeroDocumento: numDoc,
            datosContratante: datosContratante,
            esUsuario: resultadoValidacion.esUsuario,
            validaciones: resultadoValidacion.validaciones,
            idCotizacion: idCotizacion ?? undefined
          },
          ...this.getOpcionesDialogSeleccionProgramas()
        });

        dialogRefProgramas.afterClosed().subscribe(resultado => {
          if (resultado) {
            if (resultado.accion === 'guardar') {
              this.guardarEnLocalStorage({ esUsuario: resultadoValidacion.esUsuario });
            } else if (resultado.accion === 'guardar_programas') {
              this.guardarEnLocalStorage({ esUsuario: resultadoValidacion.esUsuario });
            }
          }
          // Forzar detección de cambios para recalcular botonContinuarPaso2Deshabilitado
          // ya que localStorage fue actualizado por el modal
          console.log('[CONTRATANTE] Modal cerrado, disparando detectChanges()');
          this.cdr.detectChanges();
        });
      }
    });
  }

  /**
   * Resuelve idCotizacion para abrir el modal de programas con precarga correcta.
   * Misma prioridad que getIdCotizacionEnCurso del modal: actual → creada → precargada.
   */
  private obtenerIdCotizacionActual(tipoDoc: string, numDoc: string): number | null {
    const tipo = (tipoDoc ?? '').toString().trim().toUpperCase();
    const num = (numDoc ?? '').toString().trim();

    const parseId = (value: unknown): number | null => {
      const id = Number(value);
      return Number.isFinite(id) && id > 0 ? id : null;
    };

    const docCoincide = (savedTipo: unknown, savedNum: unknown): boolean =>
      (savedTipo ?? '').toString().trim().toUpperCase() === tipo
      && (savedNum ?? '').toString().trim() === num;

    try {
      const rawActual = localStorage.getItem(this.KEY_COTIZACION_ACTUAL);
      if (rawActual) {
        const actual: CotizacionContratanteActual = JSON.parse(rawActual);
        if (docCoincide(actual.tipoDocumento, actual.numeroDocumento)) {
          const id = parseId(actual.idCotizacion);
          if (id) return id;
        }
      }
    } catch (_) { }

    try {
      const rawCreada = localStorage.getItem(KEY_COTIZACION_CREADA_DESDE_CONTRATANTE);
      if (rawCreada) {
        const saved = JSON.parse(rawCreada);
        if (docCoincide(saved?.tipoDocumento, saved?.numeroDocumento)) {
          const id = parseId(saved?.idCotizacion ?? saved?.data?.idCotizacion);
          if (id) return id;
        }
      }
    } catch (_) { }

    try {
      const rawPrec = localStorage.getItem(this.KEY_COTIZACION_PRECARGADA);
      if (rawPrec) {
        const prec = JSON.parse(rawPrec);
        const savedTipo = (prec?.tipoDocumento ?? '').toString().trim();
        const savedNum = (prec?.numeroDocumento ?? '').toString().trim();
        const docOk = !savedTipo || !savedNum || docCoincide(savedTipo, savedNum);
        if (docOk) {
          const id = parseId(prec?.idCotizacion);
          if (id) return id;
        }
      }
    } catch (_) { }

    return null;
  }

  /**
   * Guardar la elección del usuario (SI/NO) en localStorage
   */
  private guardarEleccionUsuario(tipoDocumento: string, numeroDocumento: string, esUsuario: boolean): void {
    // Guardar en localStorage
    const datosActuales = this.obtenerDatosFormulario();
    this.guardarEnLocalStorage({
      esUsuario: esUsuario,
      ...datosActuales
    });
  }

  /**
   * Precargar datos del formulario desde respuesta de AFILMED
   */
  private precargarDatosAfilmed(datos: QuotationPeopleResponse): void {
    // Extraer email principal (primer correo de la lista)
    const emailPrincipal = datos.correos && datos.correos.length > 0
      ? datos.correos[0].email
      : '';

    // Extraer email secundario (segundo correo de la lista si existe)
    const emailSecundario = datos.correos && datos.correos.length > 1
      ? datos.correos[1].email
      : '';

    // Extraer teléfono principal (primer teléfono de la lista)
    // Nota: telefonos es Array<correos> donde correos tiene { telefono: string }
    const telefono = datos.telefonos && datos.telefonos.length > 0
      ? (datos.telefonos[0] as any).telefono || ''
      : '';

    // Extraer teléfono fijo (segundo teléfono de la lista si existe)
    const telefonoFijo = datos.telefonos && datos.telefonos.length > 1
      ? (datos.telefonos[1] as any).telefono || ''
      : '';

    // Mapear género: codigoGenero puede ser 'F' o 'M'
    const genero = datos.codigoGenero === 'F' ? 'F' :
      datos.codigoGenero === 'M' ? 'M' : '';

    // Precargar formulario (conserva ñ/tildes de AFILMED)
    this.formContratante.patchValue({
      primerNombre: datos.primerNombre?.toUpperCase().trim() || '',
      segundoNombre: datos.segundoNombre?.toUpperCase().trim() || '',
      primerApellido: datos.primerApellido?.toUpperCase().trim() || '',
      segundoApellido: datos.segundoApellido?.toUpperCase().trim() || '',
      genero: genero,
      fechaNacimiento: datos.fechaNacimiento ? new Date(datos.fechaNacimiento) : null,
      emailPrincipal: emailPrincipal,
      emailSecundario: emailSecundario,
      telefono: telefono,
      telefonoFijo: telefonoFijo
    });

    // Calcular edad si hay fecha de nacimiento
    if (datos.fechaNacimiento) {
      const fechaNac = new Date(datos.fechaNacimiento);
      this.calcularEdad({ value: fechaNac } as MatDatepickerInputEvent<Date>);
    }
  }

  /**
   * Precargar datos del formulario desde respuesta del servicio de consulta de contratante
   * Mantiene mapeo defensivo para no romper flujos existentes y fuerza actualización/limpieza
   * de campos que deben reflejar siempre la última consulta por documento.
   */
  private precargarDatosContratante(datos: ContratanteData): void {
    const datosParaPrecargar: any = {};

    // Solo agregar campos que no sean null (conserva ñ/tildes)
    if (datos.primerNombre !== null && datos.primerNombre !== undefined) {
      datosParaPrecargar.primerNombre = datos.primerNombre.toUpperCase().trim();
    }

    // NC74: en nueva consulta, segundo nombre debe actualizarse o limpiarse.
    datosParaPrecargar.segundoNombre =
      datos.segundoNombre !== null && datos.segundoNombre !== undefined
        ? datos.segundoNombre.toUpperCase().trim()
        : '';

    if (datos.primerApellido !== null && datos.primerApellido !== undefined) {
      datosParaPrecargar.primerApellido = datos.primerApellido.toUpperCase().trim();
    }

    if (datos.segundoApellido !== null && datos.segundoApellido !== undefined) {
      datosParaPrecargar.segundoApellido = datos.segundoApellido.toUpperCase().trim();
    }

    if (datos.genero !== null && datos.genero !== undefined) {
      datosParaPrecargar.genero = datos.genero;
    }

    if (datos.fechaNacimiento !== null && datos.fechaNacimiento !== undefined) {
      const fechaNac = new Date(datos.fechaNacimiento);
      if (!isNaN(fechaNac.getTime())) {
        datosParaPrecargar.fechaNacimiento = fechaNac;
        // Calcular edad si hay fecha de nacimiento
        this.calcularEdad({ value: fechaNac } as MatDatepickerInputEvent<Date>);
      }
    }

    // NC74: en nueva consulta estos campos no deben conservar información anterior.
    datosParaPrecargar.emailPrincipal = (datos.email ?? '').toString().trim();
    datosParaPrecargar.emailSecundario = (datos.correoAdicional ?? '').toString().trim();
    datosParaPrecargar.telefono = (datos.celular ?? '').toString().trim();
    datosParaPrecargar.telefonoFijo = (datos.telefonoAdicional ?? '').toString().trim();

    // Solo precargar si hay al menos un dato
    if (Object.keys(datosParaPrecargar).length > 0) {
      this.formContratante.patchValue(datosParaPrecargar);
      // El valueChanges se encargará de guardar automáticamente en localStorage
    }
  }

  /**
   * NC74: consulta por lupa sin contratante (sin AFILMED ni previas, error HTTP o status sin data).
   * Vacía datos del titular consultado anteriormente; conserva tipo y número de documento actuales.
   */
  private limpiarDatosContratanteTrasBusquedaSinExito(tipoDoc: unknown, numDoc: unknown): void {
    if (this.esInclusionSoloLectura) return;

    const tipo = (tipoDoc ?? this.formContratante.get('tipoDocumento')?.value ?? '').toString();
    const num = (numDoc ?? this.formContratante.get('numeroDocumento')?.value ?? '').toString();

    this.formContratante.patchValue(
      {
        tipoDocumento: tipo,
        numeroDocumento: num,
        primerNombre: '',
        segundoNombre: '',
        primerApellido: '',
        segundoApellido: '',
        genero: '',
        fechaNacimiento: null,
        emailPrincipal: '',
        emailSecundario: '',
        telefono: '',
        telefonoFijo: '',
      },
      { emitEvent: true }
    );

    this.edad = 0;
    this.actualizarValidacionTarjetaIdentidadEdad();
  }

  calcularEdad(event: MatDatepickerInputEvent<Date> | Event): void {
    const value = (event as MatDatepickerInputEvent<Date>)?.value;
    if (value) {
      const hoy = new Date();
      const nacimiento = new Date(value);
      let edad = hoy.getFullYear() - nacimiento.getFullYear();
      const mes = hoy.getMonth() - nacimiento.getMonth();

      if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
        edad--;
      }

      this.edad = edad;
      this.actualizarValidacionTarjetaIdentidadEdad();
      // El valueChanges se encargará de guardar automáticamente en localStorage
    }
  }

  /**
   * Tipos no titulares (BG, CN, RC) y Tarjeta de identidad no permitidos como contratante titular
   * (COTIZADOR_CONTRATANTE_00): mismo error y mensaje en rojo bajo tipo de documento.
   */
  private actualizarValidacionTarjetaIdentidadEdad(): void {
    const tipoControl = this.formContratante.get('tipoDocumento');
    if (!tipoControl) return;

    const tipoVal = (tipoControl.value ?? '').toString().trim().toUpperCase();
    const item = this.listaTipoDocumento.find((d: any) => (d.codigo ?? '').toString().trim().toUpperCase() === tipoVal);
    const esTarjetaIdentidad = (item?.descripcion ?? '')
      .toUpperCase()
      .includes('TARJETA DE IDENTIDAD');

    const esTipoNoContratante = this.CODIGOS_NO_CONTRATANTE.includes(tipoVal);
    const prev = tipoControl.errors ?? {};

    if (esTipoNoContratante || esTarjetaIdentidad) {
      tipoControl.setErrors({ ...prev, tipoDocumentoNoContratante: true });
      tipoControl.markAsTouched();
    } else {
      const rest = { ...prev };
      delete rest['tipoDocumentoNoContratante'];
      delete rest['tarjetaIdentidadEdad'];
      tipoControl.setErrors(Object.keys(rest).length > 0 ? rest : null);
    }
  }

  /**
   * Validador personalizado: edad mínima 18 años para contratante
   */
  private validarEdadMinima(control: any) {
    if (control.value) {
      const hoy = new Date();
      const nacimiento = new Date(control.value);
      let edad = hoy.getFullYear() - nacimiento.getFullYear();
      const mes = hoy.getMonth() - nacimiento.getMonth();

      if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
        edad--;
      }

      return edad >= 18 ? null : { edadMinima: true };
    }
    return null;
  }

  convertirAMayusculas(controlName: string): void {

    const control = this.formContratante.get(controlName);

    if (!control) {
      return;
    }

    let value = String(control.value ?? '');

    // Mayúsculas conservando ñ/tildes (NC0107: alinear con AFILMED y el patrón del form).
    value = value.toUpperCase();

    if (controlName === 'numeroDocumento') {
      // Solo letras y números ASCII
      value = value.replace(/[^A-Z0-9]/g, '');
    } else {
      // Letras latinas (incl. Ñ/tildes), números y espacios
      value = value.replace(/[^A-ZÁÉÍÓÚÜÑ0-9 ]/g, '');
    }

    control.setValue(value, { emitEvent: false });
  }

  /** Recorta espacios al inicio/final al salir del campo (NC 186); no en cada tecla. */
  recortarBordesNombreAlBlur(nombreCampo: string): void {
    if (!this.camposNombreApellidoContratante.includes(nombreCampo)) return;
    const control = this.formContratante.get(nombreCampo);
    if (!control || control.value === null || control.value === undefined) return;
    const trimmed = String(control.value).trim();
    if (trimmed === control.value) return;
    control.setValue(trimmed, { emitEvent: true });
  }

  validarSoloNumeros(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  /** Elimina en caliente todo lo que no sea A–Z, a–z, 0–9 (p. ej. pegado desde portapapeles). */
  sanitizarNumeroDocumentoAlInput(): void {
    if (this.esInclusionSoloLectura) return;
    const control = this.formContratante.get('numeroDocumento');
    if (!control || control.value === null || control.value === undefined) return;
    const limpio = String(control.value).replace(/[^a-zA-Z0-9]/g, '');
    if (limpio !== control.value) {
      control.setValue(limpio, { emitEvent: true });
    }
  }

  campoInvalido(nombreCampo: string): boolean {
    const campo = this.formContratante.get(nombreCampo);
    return !!(campo && campo.invalid && (campo.dirty || campo.touched));
  }

  obtenerMensajeError(nombreCampo: string): string {
    const campo = this.formContratante.get(nombreCampo);

    // matDatepickerParse debe ir antes que required: texto ilegible deja el modelo sin fecha
    // y Material marca parse + required a la vez (NC 210 / COTIZADOR_CONTRATANTE_015).
    if (campo?.hasError('matDatepickerParse')) {
      return 'El formato es inválido';
    }
    if (campo?.hasError('required')) {
      return 'La información de este campo es obligatoria.';
    }
    if (campo?.hasError('pattern') && nombreCampo === 'numeroDocumento') {
      return 'Solo se permiten caracteres alfanuméricos (A-Z, a-z, 0-9).';
    }
    if (campo?.hasError('tipoDocumentoNoContratante')) {
      return 'Este tipo de documento no corresponde a un contratante. Un bebé o menor no puede ser titular del plan.';
    }
    if (campo?.hasError('email')) {
      return 'El formato es inválido';
    }
    if (campo?.hasError('pattern') && this.camposNombreApellidoContratante.includes(nombreCampo)) {
      return 'Solo se permiten letras (incl. ñ/tildes), números y espacios.';
    }
    if (campo?.hasError('minlength')) {
      return `Mínimo ${campo.errors?.['minlength'].requiredLength} caracteres`;
    }
    if (campo?.hasError('maxlength')) {
      return `Máximo ${campo.errors?.['maxlength'].requiredLength} caracteres`;
    }
    if (campo?.hasError('edadMinima')) {
      return 'El contratante debe ser mayor de 18 años';
    }

    return 'Campo inválido';
  }

  /**
   * Verifica si se puede consultar (solo tipo y número de documento)
   * Usado para habilitar la lupa de búsqueda
   */
  puedeConsultar(): boolean {
    return !!(
      this.formContratante.get('tipoDocumento')?.valid &&
      this.formContratante.get('numeroDocumento')?.valid
    );
  }

  /**
   * Verifica si se puede hacer la consulta completa (formulario completo)
   * Usado para habilitar el botón CONSULTAR
   */
  puedeConsultarCompleto(): boolean {
    // Validar que todos los campos obligatorios estén completos
    return this.formContratante.valid;
  }

  obtenerDatosFormulario(): any {
    return {
      ...this.formContratante.getRawValue(),
      edad: this.edad
    };
  }

  esFormularioValido(): boolean {
    return this.formContratante.valid;
  }

  /**
   * Verifica si el formulario tiene algún dato ingresado
   */
  formularioTieneDatos(): boolean {
    const valores = this.formContratante.getRawValue();
    return Object.keys(valores).some(key => {
      const valor = valores[key];
      return valor !== null && valor !== undefined && valor !== '';
    });
  }

  private readonly KEY_DATOS_CONTRATANTE = 'datosRQ002_Contratante';
  private readonly KEY_PROGRAMAS_CONTRATANTE = 'programas_contratante';
  private readonly KEY_VALIDACIONES_CONTRATANTE = 'validaciones_contratante';
  /** Cotización en curso (tipo/num documento + idCotizacion + fecha) para retomar y sincronizar con BD */
  private readonly KEY_COTIZACION_ACTUAL = 'cotizacion_contratante_actual';
  /** Marca que se precargó desde una cotización INCOMPLETA previa */
  private readonly KEY_COTIZACION_PRECARGADA = 'cotizacion_precargada';
  private readonly KEY_TIPO_SOLICITUD = 'tipoSolicitud';
  /** Datos del contratante inyectados desde el cotizador en modo edición */
  private readonly KEY_EDICION_CONTRATANTE = 'cotizacion_edicion_contratante';
  private readonly MENSAJE_BLOQUEO_RETIRO =
    'El sistema ha detectado que el cliente se retiró hace menos de 7 meses. Por políticas comerciales, no se permite realizar ventas nuevas en este caso.';

  /** Permite que el componente padre fuerce el modo solo lectura (ej: versión histórica). */
  @Input() soloLectura = false;

  get esInclusionSoloLectura(): boolean {
    return this.soloLectura || (localStorage.getItem(this.KEY_TIPO_SOLICITUD) ?? '').toString().trim() === '2';
  }

  /** true cuando se está editando una cotización existente (viene de mis-cotizaciones). */
  get esEditMode(): boolean {
    if (this._editModeActive) return true;
    try {
      const raw = localStorage.getItem(this.KEY_COTIZACION_PRECARGADA);
      return raw ? JSON.parse(raw)?.editMode === true : false;
    } catch (_) { return false; }
  }

  /**
   * Bloquea tipo/número de documento en venta nueva una vez creada la cotización en BD
   * para el mismo documento del formulario. No aplica en inclusión ni en edición.
   */
  get documentoBloqueadoPorCotizacion(): boolean {
    if (this.esInclusionSoloLectura) {
      return false;
    }
    if (this.esEditMode) {
      return false;
    }
    const tipoSolicitud = (localStorage.getItem(this.KEY_TIPO_SOLICITUD) ?? '').trim();
    if (tipoSolicitud !== '1') {
      return false;
    }
    return this.cotizacionGuardadaEnModalParaDocumentoActual();
  }

  /**
   * Lee la key de edición del contratante desde localStorage y, si existe, llama a precargarDesdeEdicion.
   * Se invoca en ngOnInit (carga inicial) y desde el @HostListener (cambio de versión).
   */
  private intentarPrecargarDesdeEdicion(): void {
    const raw = localStorage.getItem(this.KEY_EDICION_CONTRATANTE);
    if (!raw) return;
    try {
      const data = JSON.parse(raw);
      localStorage.removeItem(this.KEY_EDICION_CONTRATANTE);
      this.precargarDesdeEdicion(data);
    } catch (_) {
      localStorage.removeItem(this.KEY_EDICION_CONTRATANTE);
    }
  }

  /**
   * Pre-llena el formulario del contratante con los datos de la cotización en edición.
   * Escribe las keys de localStorage necesarias para que puedeContinuar() funcione sin nueva consulta.
   */
  private precargarDesdeEdicion(data: CotizacionEdicionContratanteContexto): void {
    const c = data.contratante;
    const tipoDoc = (c.tipoDocumento ?? '').toString().trim();
    const numDoc = (c.numDocumento ?? '').toString().trim();
    const esUsuario = (c.esUsuario ?? '').toString().toUpperCase() === 'S';

    this._editModeActive = true;
    this._edicionPasoActual = Number(data.pasoActual ?? 0);
    this._edicionIdTipoSolicitud = data.idTipoSolicitud ?? null;
    this._edicionTieneProgramasPersistidos = data.tieneProgramasContratantePersistidos === true;
    this._edicionProgramasContratantePersistidos = Array.isArray(data.programasContratantePersistidos)
      ? data.programasContratantePersistidos
      : [];
    this._reiniciarProgramasPorCambioPlan = data.reiniciarProgramasPorCambioPlan === true;

    const programasLocalesCoincidentes = this.programaSeleccionStore.cargarParaCotizacion(
      Number(data.idCotizacion),
      numDoc
    );
    let preservarProgramasLegacyInclusion = false;
    if (Number(data.idTipoSolicitud) === 2 && data.tieneProgramasContratantePersistidos) {
      try {
        const rawProgramas = localStorage.getItem(this.KEY_PROGRAMAS_CONTRATANTE);
        preservarProgramasLegacyInclusion = rawProgramas ? Array.isArray(JSON.parse(rawProgramas)) : false;
      } catch (_) { }
    }

    // Limpiar keys obsoletas antes de re-escribirlas
    localStorage.removeItem(this.KEY_COTIZACION_PRECARGADA);
    if (!programasLocalesCoincidentes && !preservarProgramasLegacyInclusion) {
      localStorage.removeItem(this.KEY_PROGRAMAS_CONTRATANTE);
    }
    localStorage.removeItem(this.KEY_DATOS_CONTRATANTE);

    // Pre-llenar el formulario (dispara valueChanges → guardarEnLocalStorage sin esUsuario)
    this.formContratante.patchValue({
      tipoDocumento: tipoDoc,
      numeroDocumento: numDoc,
      primerNombre: c.primerNombre ? c.primerNombre.toString().toUpperCase().trim() : null,
      segundoNombre: c.segundoNombre ? c.segundoNombre.toString().toUpperCase().trim() : null,
      primerApellido: c.primerApellido ? c.primerApellido.toString().toUpperCase().trim() : null,
      segundoApellido: c.segundoApellido ? c.segundoApellido.toString().toUpperCase().trim() : null,
      genero: c.genero ?? null,
      fechaNacimiento: c.fechaNacimiento ? new Date(c.fechaNacimiento) : null,
      emailPrincipal: c.correo ?? null,
      emailSecundario: c.correoAdicional ?? null,
      telefono: c.telefono ?? null,
      telefonoFijo: c.telefonoAdicional ?? null
    });

    // Calcular edad a partir de fecha de nacimiento
    if (c.fechaNacimiento) {
      this.calcularEdad({ value: new Date(c.fechaNacimiento) } as MatDatepickerInputEvent<Date>);
    }

    // Persistir esUsuario en datosRQ002_Contratante (guardarEnLocalStorage hace merge)
    this.guardarEnLocalStorage({ esUsuario });
    // Datos ya vienen de BD: marcar snapshot para no disparar update innecesario.
    this.cotizacionesIncompletasService.marcarDatosContratanteSincronizados();

    // Bloquear campos de identidad: solo correo y teléfono son editables en modo edición
    ['tipoDocumento', 'numeroDocumento', 'primerNombre', 'segundoNombre',
      'primerApellido', 'segundoApellido', 'genero', 'fechaNacimiento'
    ].forEach(campo => this.formContratante.get(campo)?.disable({ emitEvent: false }));

    // Escribir KEY_VALIDACIONES_CONTRATANTE con el formato esperado por puedeContinuar()
    const items = Array.isArray(c.validaciones) ? c.validaciones.map((v: any) => ({
      fuente: (v.fuente ?? '').toString(),
      descripcion: (v.descripcion ?? '').toString(),
      fechaEvento: (v.fechaEvento ?? '').toString(),
      tipo: (v.tipoAlerta ?? '').toString(),
      ...(String(v.bloqueaProceso ?? '').toUpperCase() === 'S' ? { bloquea_proceso: true } : {})
    })) : [];
    if (this._reiniciarProgramasPorCambioPlan) {
      localStorage.removeItem(this.KEY_VALIDACIONES_CONTRATANTE);
    } else {
      localStorage.setItem(this.KEY_VALIDACIONES_CONTRATANTE, JSON.stringify({
        tipoDocumento: tipoDoc,
        idContratante: numDoc,
        fechaConsulta: new Date().toISOString(),
        items
      }));
    }

    // Marcar la cotización en modo edición:
    // precargada: false → ModalSeleccionProgramas usa modo editable (subcuenta/tarifa/campaña visibles)
    // editMode: true   → señal defensiva de que este contexto es edición, no precarga de INCOMPLETA
    const idsValidaciones = Array.isArray(c.validaciones)
      ? c.validaciones.map((v: any) => Number(v.idValidacion)).filter((n: number) => Number.isFinite(n) && n > 0)
      : [];
    localStorage.setItem(this.KEY_COTIZACION_PRECARGADA, JSON.stringify({
      precargada: false,
      editMode: true,
      idCotizacion: data.idCotizacion ?? null,
      idContratante: c.idContratante ?? null,
      esUsuario: esUsuario,
      idsValidaciones,
      tipoDocumento: tipoDoc,
      numeroDocumento: numDoc,
      pasoActual: this._edicionPasoActual,
      idTipoSolicitud: this._edicionIdTipoSolicitud,
      tieneProgramasContratantePersistidos: this._edicionTieneProgramasPersistidos,
      programasContratantePersistidos: this._edicionProgramasContratantePersistidos,
      reiniciarProgramasPorCambioPlan: this._reiniciarProgramasPorCambioPlan,
      fecha: new Date().toISOString()
    }));

    console.log('Contratante precargado desde edición:', tipoDoc, numDoc, '— esUsuario:', esUsuario);
  }

  /**
   * Lee programas_contratante sin modificarlo. Exige tarifa/campaña y alinea criterios
   * con configuracionProgramasIncompleta del modal (sin depender de su estado en memoria).
   */
  private programasEnStorageCompletos(programas: any[]): boolean {
    if (!programas.length) {
      return false;
    }

    // Identificar si estamos en el flujo de inclusiones
    const tipoSolicitud = localStorage.getItem('tipoSolicitud');
    const esInclusionFlow = tipoSolicitud === '2';

    // Detectamos si el plan del contexto actual es de tipo colectivo/convenio
    const tipoPlanActual = (localStorage.getItem('tipoPlan') || '').toString().trim().toUpperCase();
    const esPlanColectivo = ['C', 'CY', 'GA', 'AG'].includes(tipoPlanActual) || tipoPlanActual.includes('COLECTIV');

    return programas.every((p) => {
      const tarifa = (p?.tarifa ?? '').toString().trim();
      const campana = (p?.campana ?? '').toString().trim();
      
      if (!tarifa || (!campana && !esInclusionFlow)) {
        return false;
      }

      const grupo = (p?.grupo ?? '').toString().trim();
      const subcuenta = (p?.subcuenta ?? '').toString().trim();
      
      if (esPlanColectivo && grupo && !subcuenta) {
        return false;
      }

      const requiereAnexo = p?.requiereAnexo === true || p?.requiereAnexo === 'S' || p?.requiereAnexo === 'si';
      if (requiereAnexo && !(p?.anexoCodigo ?? '').toString().trim()) {
        return false;
      }

      if ((p?.lineaNegocio ?? '').toString().toUpperCase() === 'CEM' && p?.coberturaValida === false) {
        return false;
      }
      return true;
    });
  }

  /**
   * Retoma incompleta avanzada (F/A/EM) o edición: no exigen GUARDAR del modal en este paso.
   */
  private excepcionContinuarSinGuardarModal(): boolean {
    if (this._editModeActive) {
      return true;
    }
    try {
      const rawPrec = localStorage.getItem(this.KEY_COTIZACION_PRECARGADA);
      const prec = rawPrec ? JSON.parse(rawPrec) : null;
      if (prec?.editMode === true) {
        return true;
      }
      const tipoPlanStored = (localStorage.getItem('tipoPlan') ?? '').toString().trim().toUpperCase();
      const pasoActual = Number(prec?.pasoActual ?? 0);
      return (
        prec?.precargada === true &&
        !['C', 'GA', 'AG'].includes(tipoPlanStored) &&
        Number.isFinite(pasoActual) &&
        pasoActual > 2
      );
    } catch (_) {
      return false;
    }
  }

  private tieneProgramasPersistidosEnEdicion(): boolean {
    if (this._editModeActive) {
      return this._edicionTieneProgramasPersistidos;
    }
    try {
      const rawPrec = localStorage.getItem(this.KEY_COTIZACION_PRECARGADA);
      const contexto: CotizacionPrecargadaContexto | null = rawPrec ? JSON.parse(rawPrec) : null;
      return contexto?.editMode === true && contexto?.tieneProgramasContratantePersistidos === true;
    } catch (_) {
      return false;
    }
  }

  /**
   * Cotización persistida tras GUARDAR en modal, para el documento actual (misma validación que el modal).
   */
private cotizacionGuardadaEnModalParaDocumentoActual(): boolean {
    try {
      // Sin visita activa (p. ej. post-F5), no bloquear aunque queden residuos en localStorage.
      if (!sessionStorage.getItem(KEY_COTIZACION_CONTRATANTE_SESION_ACTIVA)) {
        return false;
      }

      //Validamos existencia del formulario antes de extraer valores
      const tipoDocActual = (this.formContratante?.get('tipoDocumento')?.value ?? '').toString().trim().toUpperCase();
      const numDocActual = (this.formContratante?.get('numeroDocumento')?.value ?? '').toString().trim();

      if (!tipoDocActual || !numDocActual) {
        return false;
      }

      // Iniciamos un grupo en la consola para agrupar los logs de auditoría de forma estética

      // ── CAMINO A: VENTA NUEVA TRADICIONAL ──────────────────────────────────
      const rawCreada = localStorage.getItem(KEY_COTIZACION_CREADA_DESDE_CONTRATANTE);
      if (rawCreada) {
        const saved = JSON.parse(rawCreada);
        const tipoDocSaved = (saved?.tipoDocumento ?? '').toString().trim().toUpperCase();
        const numDocSaved = (saved?.numeroDocumento ?? '').toString().trim();

        if (tipoDocSaved === tipoDocActual && numDocSaved === numDocActual) {
          const id = Number(saved?.idCotizacion ?? saved?.data?.idCotizacion ?? 0);
          if (Number.isFinite(id) && id > 0) {
            return true;
          }
        }
      }

      // ── CAMINO B: INCLUSIONES Y RETOMAS INCOMPLETAS AVANZADAS ───────────────
      const rawPrecargada = localStorage.getItem(this.KEY_COTIZACION_PRECARGADA);
      if (rawPrecargada) {
        const prec = JSON.parse(rawPrecargada);
        const savedTipo = (prec?.tipoDocumento ?? '').toString().trim().toUpperCase();
        const savedNum = (prec?.numeroDocumento ?? '').toString().trim();

        if (savedTipo === tipoDocActual && savedNum === numDocActual) {
          const id = Number(prec?.idCotizacion ?? 0);
          if (Number.isFinite(id) && id > 0) {
            return true;
          }
        }
      }

      // ── CAMINO C: CONTEXTO DE COTIZACIÓN ACTIVA EN CURSO ───────────────────
      const rawActual = localStorage.getItem(this.KEY_COTIZACION_ACTUAL);
      if (rawActual) {
        const actual = JSON.parse(rawActual);
        const savedTipo = (actual?.tipoDocumento ?? '').toString().trim().toUpperCase();
        const savedNum = (actual?.numeroDocumento ?? '').toString().trim();

        if (savedTipo === tipoDocActual && savedNum === numDocActual) {
          const id = Number(actual?.idCotizacion ?? 0);
          if (Number.isFinite(id) && id > 0) {
            return true;
          }
        }
      }

      // Si llegó hasta aquí, ninguna de las claves del LocalStorage coincide con el usuario en pantalla
      return false;

    } catch (error) {
      try { console.groupEnd(); } catch (_) {}
      return false;
    }
  }

  /** NC408: la flecha exige GUARDAR en modal salvo retoma incompleta avanzada o edición. */
  private flujoContratantePermiteContinuar(): boolean {
    if (this.excepcionContinuarSinGuardarModal()) {
      return true;
    }
    return this.cotizacionGuardadaEnModalParaDocumentoActual();
  }

  /**
   * Valida el formulario, que se haya elegido Sí/No (esUsuario) y, si es usuario, que haya programas seleccionados.
   * Método público para ser usado por el componente padre (cotizador).
   */
  puedeContinuar(): boolean {
    if (!this.esFormularioValido()) {
      return false;
    }
    const datosStr = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
    let datos: { esUsuario?: boolean } = {};
    if (datosStr) {
      try {
        datos = JSON.parse(datosStr);
      } catch (_) { }
    }
    if (datos.esUsuario === undefined) {
      try {
        const rawPrec = localStorage.getItem(this.KEY_COTIZACION_PRECARGADA);
        const prec = rawPrec ? JSON.parse(rawPrec) : null;
        if (prec?.editMode === true && typeof prec?.esUsuario === 'boolean') {
          datos.esUsuario = prec.esUsuario;
        }
      } catch (_) { }
      if (datos.esUsuario === undefined) return false;
    }
    if (datos.esUsuario === true) {
      const programasStr = localStorage.getItem(this.KEY_PROGRAMAS_CONTRATANTE);
      let programas: any[] = [];
      if (programasStr) {
        try {
          const parsed = JSON.parse(programasStr);
          if (Array.isArray(parsed)) {
            programas = parsed;
          } else if (parsed && Array.isArray(parsed.programas)) {
            // Formato nuevo del ProgramaSeleccionStore: envelope { idCotizacion, programas: [...] }
            programas = parsed.programas;
          }
        } catch (_) { }
      }
      if (programas.length > 0) {
        if (!this.programasEnStorageCompletos(programas)) return false;
      } else if (!this.tieneProgramasPersistidosEnEdicion()) {
        return false;
      }
    }
    // NOTA: se retira el bloqueo por MENSAJE_BLOQUEO_RETIRO (retiro < 7 meses).
    // Antes: si tipoSolicitud === '1' y había items con bloquea_proceso === true, se retornaba false.
    // Ahora ya no se evalúa como condición de bloqueo; el mensaje sigue disponible en getMensajeErrorContinuar()
    // solo como información, pero no impide continuar.
    return this.flujoContratantePermiteContinuar();
  }

  /**
   * Mensaje de error para mostrar cuando no se puede continuar (falta esUsuario, programas o formulario).
   */
  getMensajeErrorContinuar(): string {
    if (!this.esFormularioValido()) {
      return 'Faltan campos por diligenciar en el formulario del contratante';
    }
    const datosStr = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
    let datos: { esUsuario?: boolean } = {};
    if (datosStr) {
      try {
        datos = JSON.parse(datosStr);
      } catch (_) { }
    }
    if (datos.esUsuario === undefined) {
      try {
        const rawPrec = localStorage.getItem(this.KEY_COTIZACION_PRECARGADA);
        const prec = rawPrec ? JSON.parse(rawPrec) : null;
        if (prec?.editMode === true && typeof prec?.esUsuario === 'boolean') {
          datos.esUsuario = prec.esUsuario;
        }
      } catch (_) { }
      if (datos.esUsuario === undefined) {
        return 'Debe indicar si el contratante es usuario (Sí/No) antes de continuar.';
      }
    }
    if (datos.esUsuario === true) {
      const programasStr = localStorage.getItem(this.KEY_PROGRAMAS_CONTRATANTE);
      let programas: any[] = [];
      if (programasStr) {
        try {
          const parsed = JSON.parse(programasStr);
          if (Array.isArray(parsed)) {
            programas = parsed;
          } else if (parsed && Array.isArray(parsed.programas)) {
            // Formato nuevo del ProgramaSeleccionStore: envelope { idCotizacion, programas: [...] }
            programas = parsed.programas;
          }
        } catch (_) { }
      }
      if (programas.length > 0) {
        if (!this.programasEnStorageCompletos(programas)) {
          return 'Debe completar la configuración de los programas (subcuenta, tarifa y campaña) antes de continuar.';
        }
      } else if (!this.tieneProgramasPersistidosEnEdicion()) {
        return 'Debe seleccionar al menos un programa para continuar.';
      }
    }
    // Se comenta el bloque de código que devolvía MENSAJE_BLOQUEO_RETIRO como bloqueo.
    // const tipoSolicitud = localStorage.getItem(this.KEY_TIPO_SOLICITUD);
    // if (tipoSolicitud === '1') {
    //   const validacionesStr = localStorage.getItem(this.KEY_VALIDACIONES_CONTRATANTE);
    //   if (validacionesStr) {
    //     try {
    //       const validaciones = JSON.parse(validacionesStr);
    //       if (Array.isArray(validaciones?.items) && validaciones.items.some((i: any) => i.bloquea_proceso === true)) {
    //         return this.MENSAJE_BLOQUEO_RETIRO;
    //       }
    //     } catch (_) { }
    //   }
    // }
    if (!this.flujoContratantePermiteContinuar()) {
      return 'Debe consultar y guardar la selección de programas antes de continuar.';
    }
    return 'Faltan campos por diligenciar en el formulario del contratante';
  }

  /**
   * Método público para obtener los datos del formulario y guardarlos antes de continuar
   * Retorna los datos si el formulario es válido, null en caso contrario
   */
  obtenerDatosParaContinuar(): any {
    if (!this.esFormularioValido()) {
      return null;
    }

    // Guardar en localStorage antes de continuar
    this.guardarEnLocalStorage();

    return this.obtenerDatosFormulario();
  }

  /**
   * Limpia completamente el formulario y resetea validaciones.
   * En modo edición, conserva los valores de los controles deshabilitados (identidad del contratante)
   * y solo limpia los controles que están habilitados para edición.
   */
  limpiarFormulario(): void {
    if (this.esInclusionSoloLectura) return;

    // En modo edición, capturar valores de controles deshabilitados antes del reset
    // y leer los flags de localStorage (esUsuario, idAsesor) ANTES de borrarlos,
    // para restaurarlos al final y evitar que consultarValidaciones abra el modal de nuevo
    const valoresDeshabilitados: { [key: string]: any } = {};
    let extrasEditMode: { esUsuario?: boolean; idAsesor?: string } = {};
    if (this.esEditMode) {
      Object.keys(this.formContratante.controls).forEach(key => {
        const control = this.formContratante.get(key);
        if (control && control.disabled) {
          valoresDeshabilitados[key] = control.value;
        }
      });
      try {
        const raw = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
        if (raw) {
          const parsed = JSON.parse(raw);
          if (typeof parsed?.esUsuario === 'boolean') extrasEditMode.esUsuario = parsed.esUsuario;
          if (parsed?.idAsesor) extrasEditMode.idAsesor = parsed.idAsesor;
        }
      } catch (_) { }
    }

    // Resetear el formulario (esto ejecuta automáticamente los validators)
    this.formContratante.reset();
    this.edad = 0;
    this.buscando = false;

    // En modo edición, restaurar los valores de los controles deshabilitados
    if (this.esEditMode && Object.keys(valoresDeshabilitados).length > 0) {
      this.formContratante.patchValue(valoresDeshabilitados, { emitEvent: false });

      // Recalcular la edad desde la fecha de nacimiento restaurada
      const fechaNac = valoresDeshabilitados['fechaNacimiento'];
      if (fechaNac) {
        const hoy = new Date();
        const nacimiento = new Date(fechaNac);
        let edad = hoy.getFullYear() - nacimiento.getFullYear();
        const mes = hoy.getMonth() - nacimiento.getMonth();
        if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
          edad--;
        }
        this.edad = edad;
        this.actualizarValidacionTarjetaIdentidadEdad();
      }
    }

    // Limpiar localStorage
    localStorage.removeItem('datosRQ002_Contratante');
    localStorage.removeItem('validaciones_contratante');
    localStorage.removeItem('programas_contratante');
    if (!this.esEditMode) {
      localStorage.removeItem(this.KEY_COTIZACION_ACTUAL);
      localStorage.removeItem(KEY_COTIZACION_CREADA_DESDE_CONTRATANTE);
      // NC0107: LIMPIAR también debe soltar precargada; si queda, el modal reusa idCotizacion viejo.
      localStorage.removeItem(this.KEY_COTIZACION_PRECARGADA);
      sessionStorage.removeItem(KEY_COTIZACION_CONTRATANTE_SESION_ACTIVA);
      this.cotizacionesIncompletasService.limpiarSnapshotDatosContratante();
      this.limpiarBeneficiariosLocalGuardados();
    }

    // Marcar todos los controles como untouched y pristine para ocultar mensajes de error
    // NO usar setErrors(null) porque eso elimina los errores de validación
    Object.keys(this.formContratante.controls).forEach(key => {
      const control = this.formContratante.get(key);
      if (control) {
        control.markAsUntouched();
        control.markAsPristine();
        // NO hacer setErrors(null) - dejar que los validators funcionen naturalmente
      }
    });

    // En modo edición, re-sincronizar localStorage con el estado actual
    // (campos de identidad restaurados + campos editables vacíos)
    // Se pasan los flags capturados antes del borrado para que guardarEnLocalStorage
    // los incluya en el merge y no se pierda esUsuario ni idAsesor
    if (this.esEditMode) {
      this.guardarEnLocalStorage(Object.keys(extrasEditMode).length > 0 ? extrasEditMode : undefined);
    }
  }


  // ============================================================
  // MÉTODOS PARA INTEGRACIÓN CON RQ001 (localStorage)
  // ============================================================

  /**
   * Cargar datos del paso anterior (RQ001) desde localStorage
   * También carga datos de contrato_radicado si existe
   * Después de cargar, espera 1 segundo y ejecuta automáticamente la búsqueda
   */
  cargarDatosDesdeLocalStorage(): void {
    // Solo usar contrato_radicado cuando es inclusión (tipoSolicitud === '2')
    const tipoSolicitud = localStorage.getItem(this.KEY_TIPO_SOLICITUD);
    if (tipoSolicitud !== '2') {
      return;
    }

    const contratoRadicado = localStorage.getItem('contrato_radicado');
    if (!contratoRadicado) {
      return;
    }

    try {
      const datos = JSON.parse(contratoRadicado);
      // if (datos?.contrato && Array.isArray(datos.contrato) && datos.contrato.length > 0) {
      //   const primerContrato = datos.contrato[0];
      //   if (primerContrato?.docu_tipo && primerContrato?.docu_nro) {
      //     this.formContratante.patchValue({
      //       tipoDocumento: primerContrato.docu_tipo.trim(),
      //       numeroDocumento: primerContrato.docu_nro.trim()
      //     });
      //     console.log('Datos precargados desde contrato_radicado (inclusión):', {
      //       tipoDocumento: primerContrato.docu_tipo.trim(),
      //       numeroDocumento: primerContrato.docu_nro.trim()
      //     });
      //     timer(1000).pipe(take(1)).subscribe(() => {
      //       if (this.puedeConsultar()) {
      //         this.buscarContratante();
      //       }
      //     });
      //   }
      const tipoDocumento = (
        datos?.tipoDocumento ??
        datos?.persona?.tipoDocumento ??
        datos?.persona?.docu_tipo ??
        datos?.persona?.docu_tipo_benef ??
        datos?.contrato?.[0]?.docu_tipo ??
        datos?.Contrato?.[0]?.docu_tipo ??
        ''
      ).toString().trim();

      const numeroDocumento = (
        datos?.numeroDocumento ??
        datos?.persona?.documento ??
        datos?.persona?.docu_nro ??
        datos?.persona?.docu_nro_benef ??
        datos?.contrato?.[0]?.docu_nro ??
        datos?.Contrato?.[0]?.docu_nro ??
        ''
      ).toString().trim();

      if (tipoDocumento && numeroDocumento) {
        this.formContratante.patchValue({
          tipoDocumento,
          numeroDocumento
        });

        console.log('Datos precargados desde contrato_radicado (inclusión):', {
          tipoDocumento,
          numeroDocumento
        });

        timer(1000).pipe(take(1)).subscribe(() => {
          if (this.puedeConsultar()) {
            this.buscarContratante();
          }
        });
      }
    } catch (error) {
      console.error('Error al parsear datos de contrato_radicado:', error);
    }
  }

  /**
   * Obtiene el IdAsesor del usuario logueado desde contrato_radicado (inclusión) o desde cache (venta nueva, obtenido por sessionStorage + CodigoAsesorService).
   */
  private obtenerIdAsesorLogueado(): string | null {
    
    const tipoSolicitud = localStorage.getItem(this.KEY_TIPO_SOLICITUD);
    if (tipoSolicitud === '2') {
      const idAsesorRealSesion = localStorage.getItem('idAsesorAutenticadoGlobal');
      if (idAsesorRealSesion) {
        return idAsesorRealSesion.trim();
      }
    }
    const contratoRadicado = localStorage.getItem('contrato_radicado');
    if (contratoRadicado) {
      try {
        const datos = JSON.parse(contratoRadicado);
        if (datos?.contrato && Array.isArray(datos.contrato) && datos.contrato.length > 0) {
          const id = datos.contrato[0]?.IdAsesor?.toString()?.trim() || null;
          if (id) return id;
        }
      } catch (error) {
        console.error('Error al parsear datos de contrato_radicado:', error);
      }
    }
    return this.idAsesorLogueadoCache ?? null;
  }

  /**
   * Obtiene el IdAsesor del usuario logueado de forma asíncrona: desde contrato_radicado (inclusión) o consultando por documento en sessionStorage (venta nueva).
   */
  private obtenerIdAsesorLogueadoObservable(): Observable<string | null> {
   
    const tipoSolicitud = localStorage.getItem(this.KEY_TIPO_SOLICITUD);
    if (tipoSolicitud === '2') {
      const idAsesorRealSesion = localStorage.getItem('idAsesorAutenticadoGlobal');
      if (idAsesorRealSesion) {
        console.log(`[Inclusion-Guard] obteniendo asesor real de la sesión: ${idAsesorRealSesion}`);
        return of(idAsesorRealSesion.trim());
      }
    }

    const contratoRadicado = localStorage.getItem('contrato_radicado');
    if (contratoRadicado) {
      try {
        const datos = JSON.parse(contratoRadicado);
        if (datos?.contrato && Array.isArray(datos.contrato) && datos.contrato.length > 0) {
          const id = datos.contrato[0]?.IdAsesor?.toString()?.trim() || null;
          if (id) return of(id);
        }
      } catch (_) { }
    }
    const userStr = sessionStorage.getItem('user');
    if (!userStr) return of(null);
    let user: { document?: string };
    try {
      user = JSON.parse(userStr);
    } catch (_) {
      return of(null);
    }
    const documento = user?.document?.replace(/\D/g, '')?.trim();
    if (!documento) return of(null);
    // Usar el endpoint local para evitar dependencia del servicio que apunta a prod.
    return this.networkingQuotation.getCodigoAsesor(documento).pipe(
      take(1),
      map((asesor: any) => {
        const id = asesor?.idasesor ?? asesor?.idAsesor ?? asesor?.IdAsesor;
        return id != null && String(id).trim() !== '' ? String(id) : null;
      }),
      catchError(() => of(null))
    );
  }

  /**
   * Garantiza que datosRQ002_Contratante tenga idAsesor aunque no se use la lupa.
   * No sobrescribe si ya existe un idAsesor válido.
   */
  private asegurarIdAsesorEnStorage(): void {
    try {
      const raw = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
      if (raw) {
        const parsed = JSON.parse(raw);
        const idActual = (parsed?.idAsesor ?? '').toString().trim();
        if (idActual) return;
      }
    } catch (_) { }

    this.obtenerIdAsesorLogueadoObservable().pipe(take(1)).subscribe(idAsesor => {
      const id = (idAsesor ?? '').toString().trim();
      if (!id) {
        console.warn('No se pudo hidratar idAsesor al iniciar el formulario de contratante.');
        return;
      }
      this.idAsesorLogueadoCache = id;
      this.guardarEnLocalStorage({ idAsesor: id });
    });
  }

  /**
   * Procesa todas las cotizaciones previas y carga los nombres de los asesores que sean diferentes al logueado
   * Retorna un Observable que se completa cuando todas las llamadas al servicio han terminado
   * @param cotizaciones Array de cotizaciones previas
   * @returns Observable que se completa cuando todas las consultas de asesores han terminado
   */
  private procesarAsesoresCotizacionesPrevias(cotizaciones: CotizacionPrevia[]): Observable<void> {
    if (!cotizaciones || cotizaciones.length === 0) {
      return of(void 0);
    }

    // Obtener el idAsesor del usuario logueado
    const idAsesorLogueado = this.obtenerIdAsesorLogueado();

    if (!idAsesorLogueado) {
      console.warn('No se pudo obtener el IdAsesor del usuario logueado');
      return of(void 0);
    }

    const idAsesorLogueadoStr = idAsesorLogueado.trim();

    // Extraer todos los idAsesor únicos de las cotizaciones
    const idAsesoresUnicos = new Set<string>();

    cotizaciones.forEach(cotizacion => {
      const idAsesorCotizacion = cotizacion.idAsesor?.toString()?.trim();
      if (idAsesorCotizacion && idAsesorCotizacion !== '') {
        idAsesoresUnicos.add(idAsesorCotizacion);
      }
    });

    // Filtrar solo los idAsesor que sean diferentes al logueado
    const idAsesoresDiferentes = Array.from(idAsesoresUnicos).filter(
      idAsesor => idAsesor !== idAsesorLogueadoStr
    );

    console.log(`Se encontraron ${idAsesoresDiferentes.length} asesores diferentes al logueado:`, idAsesoresDiferentes);

    // Si no hay asesores diferentes, retornar un Observable completado inmediatamente
    if (idAsesoresDiferentes.length === 0) {
      return of(void 0);
    }

    // Crear un array de Observables, uno por cada idAsesor diferente
    const observables = idAsesoresDiferentes.map(idAsesor =>
      this.cargarNombreAsesorObservable(idAsesor).pipe(
        catchError(error => {
          console.error(`Error al cargar nombre del asesor ${idAsesor}:`, error);
          return of(null); // Continuar aunque haya un error
        })
      )
    );

    // Usar forkJoin para esperar a que todas las llamadas se completen
    return forkJoin(observables).pipe(
      map(() => void 0) // Convertir el resultado a void
    );
  }

  /**
   * Carga el nombre del asesor desde el servicio usando el idAsesor proporcionado
   * Retorna un Observable que se completa cuando se obtiene el nombre
   * @param idAsesor El ID del asesor a consultar (obligatorio)
   * @returns Observable que emite el nombre del asesor o null si hay error
   */
  private cargarNombreAsesorObservable(idAsesor: string): Observable<string | null> {
    if (!idAsesor || !idAsesor.trim()) {
      console.warn('No se proporcionó idAsesor para consultar');
      return of(null);
    }

    const idAsesorParaConsultar = idAsesor.trim();

    // Construir el request según el formato requerido
    const request: ConsultarAsesorByIDRequest = {
      nombreClave: 'getSpCotConsultarAsesorPorID',
      jsonParametros: JSON.stringify({
        prm_id_asesor: idAsesorParaConsultar
      })
    };

    console.log('Consultando asesor con request:', request);

    // Llamar al servicio y retornar el Observable
    return this.consultarAsesorByIDService.consultarAsesorByID(request).pipe(
      map((response) => {
        if (response.status && response.data && response.data.length > 0) {
          // Obtener el nombre completo del primer asesor encontrado
          const nombreAsesorEncontrado = response.data[0].NombreCompleto || '';
          console.log(`Nombre del asesor ${idAsesorParaConsultar} cargado:`, nombreAsesorEncontrado);

          // Almacenar el nombre del asesor en el Map usando su ID como clave
          this.nombresAsesores.set(idAsesorParaConsultar, nombreAsesorEncontrado);

          // Si es el primer asesor o si no hay nombre almacenado, guardarlo en nombreAsesor
          // (para compatibilidad con código existente)
          if (!this.nombreAsesor) {
            this.nombreAsesor = nombreAsesorEncontrado;
          }

          return nombreAsesorEncontrado;
        } else {
          console.warn(`No se encontró información del asesor ${idAsesorParaConsultar}:`, response.message);
          return null;
        }
      }),
      catchError((error) => {
        console.error(`Error al consultar asesor ${idAsesorParaConsultar} por ID:`, error);
        return of(null);
      })
    );
  }

  /**
   * Carga el nombre del asesor desde el servicio usando el idAsesor proporcionado
   * Versión síncrona (para compatibilidad con código existente)
   * @param idAsesor El ID del asesor a consultar (obligatorio)
   */
  private cargarNombreAsesor(idAsesor: string): void {
    this.cargarNombreAsesorObservable(idAsesor).subscribe();
  }

  /**
   * Guardar datos del contratante en localStorage para siguiente paso.
   * Siempre hace merge con lo ya guardado para preservar idAsesor, flags y esUsuario entre llamadas.
   */
  guardarEnLocalStorage(datosAdicionales?: any): void {
    const datosFormulario = this.obtenerDatosFormulario();
    let datosParaGuardar: any = { ...datosFormulario, edad: this.edad };

    let existingParsed: any = null;
    const existing = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
    if (existing) {
      try {
        const parsed = JSON.parse(existing);
        existingParsed = parsed;
        if (parsed.esUsuario !== undefined) datosParaGuardar.esUsuario = parsed.esUsuario;
        if (parsed.idAsesor !== undefined) datosParaGuardar.idAsesor = parsed.idAsesor;
        if (parsed.flagExisteCotizacionOtroAsesor !== undefined) datosParaGuardar.flagExisteCotizacionOtroAsesor = parsed.flagExisteCotizacionOtroAsesor;
        if (parsed.flagExisteContratoOtroAsesor !== undefined) datosParaGuardar.flagExisteContratoOtroAsesor = parsed.flagExisteContratoOtroAsesor;
        // Mantener cualquier campo existente (incluye ids de beneficiario) y
        // luego sobreescribir solo con los datos actuales del formulario.
        datosParaGuardar = {
          ...parsed,
          ...datosParaGuardar,
        };
      } catch (_) { }
    }

    if (datosAdicionales != null && Object.keys(datosAdicionales).length > 0) {
      datosParaGuardar = { ...datosParaGuardar, ...datosAdicionales };
    }

    if (this.cambioContextoBaseContratante(existingParsed, datosParaGuardar)) {
      // Solo limpia drafts obsoletos. NO borra datosRQ003_Beneficiario ni
      // programas_beneficiario: esos se limpian solo si cambia el documento
      // (lupa) o el plan/solicitud de inicio.
      this.limpiarDraftBeneficiarios();
    }

    localStorage.setItem(this.KEY_DATOS_CONTRATANTE, JSON.stringify(datosParaGuardar));
    console.log('Datos guardados en localStorage:', datosParaGuardar);
  }

  private cambioContextoBaseContratante(anterior: any, actual: any): boolean {
    if (!anterior) {
      return false;
    }

    const normalize = (v: any) => (v ?? '').toString().trim();
    const normalizeFecha = (v: any): string => {
      if (v === null || v === undefined || v === '') return '';
      if (v instanceof Date && !Number.isNaN(v.getTime())) {
        const yyyy = v.getFullYear();
        const mm = String(v.getMonth() + 1).padStart(2, '0');
        const dd = String(v.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
      }
      const raw = normalize(v);
      const dmy = raw.match(/^(\d{2})[\/\-](\d{2})[\/\-](\d{4})$/);
      if (dmy) return `${dmy[3]}-${dmy[2]}-${dmy[1]}`;
      const ymd = raw.match(/^(\d{4})[\/\-](\d{2})[\/\-](\d{2})/);
      if (ymd) return `${ymd[1]}-${ymd[2]}-${ymd[3]}`;
      const parsed = new Date(raw);
      if (!Number.isNaN(parsed.getTime())) {
        const yyyy = parsed.getFullYear();
        const mm = String(parsed.getMonth() + 1).padStart(2, '0');
        const dd = String(parsed.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
      }
      return raw;
    };

    return (
      normalize(anterior.tipoDocumento) !== normalize(actual.tipoDocumento) ||
      normalize(anterior.numeroDocumento) !== normalize(actual.numeroDocumento) ||
      normalize(anterior.genero) !== normalize(actual.genero) ||
      normalizeFecha(anterior.fechaNacimiento) !== normalizeFecha(actual.fechaNacimiento)
    );
  }

  private limpiarDraftBeneficiarios(): void {
    localStorage.removeItem('datosRQ003_Beneficiarios');
  }

  private limpiarBeneficiariosLocalGuardados(): void {
    localStorage.removeItem('datosRQ003_Beneficiarios');
    localStorage.removeItem('datosRQ003_Beneficiario');
    localStorage.removeItem('programas_beneficiario');
  }

  // ============================================================
  // MÉTODOS PARA MANEJO DE ERRORES (RQ002)
  // ============================================================

  /**
   * Mostrar mensaje de error estándar según RQ002
   */
  mostrarMensajeError(tipoDocumento?: string, numeroDocumento?: string): void {
    const tipo = (tipoDocumento ?? this.formContratante.get('tipoDocumento')?.value ?? '').toString().trim();
    const numero = (numeroDocumento ?? this.formContratante.get('numeroDocumento')?.value ?? '').toString().trim();
    const mensaje = `No se encontraron datos para el tipo de documento <strong>${tipo || 'N/A'}</strong> y número <strong>${numero || 'N/A'}</strong>.`;
    this.dialog.open(PopUpMensajeComponent, {
      width: '600px',
      maxWidth: '90vw',
      disableClose: true,
      data: {
        titulo: 'Sin resultados',
        texto: mensaje,
        tipoIcono: 'error',
        textoBoton: 'ACEPTAR'
      } as PopUpMensajeData
    });
  }

  // ============================================================
  // MÉTODOS PARA VERIFICACIÓN DE COTIZACIONES PREVIAS
  // ============================================================

  // ============================================================
  // CONTRATO ACTIVO AFILMED ASOCIADO A OTRO ASESOR (solo venta nueva)
  // ============================================================

  /**
   * Verifica si el usuario tiene contrato(s) activo(s) asociado(s) a un asesor diferente al logueado.
   * Solo se ejecuta cuando tipoSolicitud === '1' (venta nueva). Usa usuario-activo/contratos (getRFDusuarioMP), mismo que el cotizador.
   */
  private verificarContratoActivoAfilmedOtroAsesor(tipoDocumento: string, numeroDocumento: string): void {
    this.networkingQuotation.consultarContratos(numeroDocumento, tipoDocumento).pipe(
      catchError(() => of([] as ContratosActivos[]))
    ).subscribe((contratos) => {
      if (!contratos || contratos.length === 0) {
        this.guardarEnLocalStorage({ flagExisteContratoOtroAsesor: 'N' });
        return;
      }
      const idAsesorLogueado = this.obtenerIdAsesorLogueado()?.trim() ?? '';
      const nombresOtrosAsesores = new Set<string>();
      contratos.forEach((c) => {
        const idAsesor = String(c.IdAsesor ?? '').trim();
        if (idAsesor && idAsesor !== idAsesorLogueado) {
          const nombre = (c.nombreAsesor ?? '').trim() || idAsesor;
          nombresOtrosAsesores.add(nombre);
        }
      });
      this.guardarEnLocalStorage({ flagExisteContratoOtroAsesor: nombresOtrosAsesores.size > 0 ? 'S' : 'N' });
      if (nombresOtrosAsesores.size === 0) {
        return;
      }
      this.mostrarPopUpContratoActivoAfilmedOtroAsesor(Array.from(nombresOtrosAsesores));
    });
  }

  /**
   * Muestra el pop-up de contrato activo en Afilmed asociado al asesor de población.
   * Reutiliza el mismo modal y patrón que la alerta de cotizaciones previas.
   */
  private mostrarPopUpContratoActivoAfilmedOtroAsesor(nombresAsesores: string[]): void {
    const nombresTexto = nombresAsesores.length > 0 ? nombresAsesores.join(', ') : 'N/A';
    const mensaje = `Existe un contrato activo en Afilmed para este usuario, asociado al asesor de población <strong>${nombresTexto}</strong>.`;
    this.dialog.open(PopUpMensajeComponent, {
      width: '600px',
      maxWidth: '90vw',
      disableClose: true,
      data: {
        titulo: 'Advertencia',
        texto: mensaje,
        tipoIcono: 'warning',
        textoBoton: 'ACEPTAR'
      } as PopUpMensajeData
    });
  }

  /**
   * Verifica si hay cotizaciones previas con asesores diferentes al logueado
   * y muestra un pop-up con la información de todas las cotizaciones encontradas
   */
  private verificarAsesoresCotizacionesPrevias(cotizaciones: CotizacionPrevia[]): void {
    if (!cotizaciones || cotizaciones.length === 0) {
      this.guardarEnLocalStorage({ flagExisteCotizacionOtroAsesor: 'N' });
      return;
    }

    const idAsesorLogueado = this.obtenerIdAsesorLogueado();
    if (!idAsesorLogueado) {
      console.warn('No se pudo obtener el IdAsesor del usuario logueado');
      return;
    }

    const idAsesorLogueadoStr = idAsesorLogueado.toString().trim();

    // Filtrar solo cotizaciones con estados permitidos: GUARDADA, ENVIADA, ACEPTADA
    const estadosPermitidos = ['GUARDADA', 'ENVIADA', 'ACEPTADA'];
    const cotizacionesFiltradas = cotizaciones.filter(cot =>
      estadosPermitidos.includes(cot.estado?.toUpperCase() || '')
    );

    // Si no hay cotizaciones con estados permitidos, no mostrar pop-up
    if (cotizacionesFiltradas.length === 0) {
      this.guardarEnLocalStorage({ flagExisteCotizacionOtroAsesor: 'N' });
      return;
    }

    // Filtrar todas las cotizaciones con asesores diferentes al logueado
    const cotizacionesConAsesoresDiferentes = cotizacionesFiltradas.filter(
      cotizacion => {
        // Comparar el idAsesor de la cotización con el IdAsesor del logueado
        // Convertir ambos a string para asegurar la comparación
        const idAsesorCotizacion = cotizacion.idAsesor?.toString()?.trim() || '';
        return idAsesorCotizacion !== idAsesorLogueadoStr && idAsesorCotizacion !== '';
      }
    );

    this.guardarEnLocalStorage({ flagExisteCotizacionOtroAsesor: cotizacionesConAsesoresDiferentes.length > 0 ? 'S' : 'N' });

    // Si se encontraron cotizaciones con asesores diferentes, mostrar el pop-up
    if (cotizacionesConAsesoresDiferentes.length > 0) {
      this.mostrarPopUpCotizacionAsesorDiferente(cotizacionesConAsesoresDiferentes);
    }
  }

  /**
   * Muestra el pop-up indicando que existen cotizaciones previas con otros asesores.
   * RQ002 / NC0032: un solo nombre por asesor, sin estados.
   */
  private mostrarPopUpCotizacionAsesorDiferente(cotizaciones: CotizacionPrevia[]): void {
    if (!cotizaciones || cotizaciones.length === 0) {
      return;
    }

    // Una sola fila por asesor (sin repetir nombre ni mostrar estado)
    const vistos = new Set<string>();
    const cotizacionesUnicas = cotizaciones.filter((cotizacion) => {
      const idAsesor = (cotizacion.idAsesor ?? '').toString().trim();
      if (!idAsesor || vistos.has(idAsesor)) {
        return false;
      }
      vistos.add(idAsesor);
      return true;
    });

    const items = cotizacionesUnicas.map((cotizacion) => {
      const idAsesor = cotizacion.idAsesor?.toString()?.trim() || '';
      const nombreAsesor = this.nombresAsesores.get(idAsesor) || idAsesor || 'N/A';
      return `<li><strong>${nombreAsesor}</strong></li>`;
    }).join('');
    const mensaje = `<div style="font-size: 1rem; line-height: 1.5;">Existe una cotización activa en gestión realizada por:<br/><ul style="margin: 0.5em 0 0 1em; padding-left: 1em;">${items}</ul></div>`;

    this.dialog.open(PopUpMensajeComponent, {
      width: '600px',
      maxWidth: '90vw',
      disableClose: true,
      data: {
        titulo: 'Advertencia',
        texto: mensaje,
        tipoIcono: 'warning',
        textoBoton: 'ACEPTAR'
      } as PopUpMensajeData
    });
  }
}
